
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("g2oof", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $hekY6 = parcelRequire("hekY6");


var $jiJCD = parcelRequire("jiJCD");


var $cozmU = parcelRequire("cozmU");


var $5sUij = parcelRequire("5sUij");


var $9DHhW = parcelRequire("9DHhW");


var $6H0Pg = parcelRequire("6H0Pg");


var $lTECB = parcelRequire("lTECB");


var $1eD4P = parcelRequire("1eD4P");


var $lJlG6 = parcelRequire("lJlG6");


var $e2zD6 = parcelRequire("e2zD6");


var $7mpOv = parcelRequire("7mpOv");


var $jmjWc = parcelRequire("jmjWc");


const $f23f475309e66803$export$9533f8bbe7f6f635 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "SZhro",
    name: "AIFloatingContextMenuLoadable",
    loader: async ()=>(await (parcelRequire("95SZM"))).AIFloatingContextMenu
});



var $cZa7r = parcelRequire("cZa7r");


var $a8ZQ3 = parcelRequire("a8ZQ3");


var $deZfn = parcelRequire("deZfn");


var $iVU5h = parcelRequire("iVU5h");


var $iSXh4 = parcelRequire("iSXh4");


var $cryCi = parcelRequire("cryCi");


var $fNzRA = parcelRequire("fNzRA");


var $4r9Ir = parcelRequire("4r9Ir");


var $7IghX = parcelRequire("7IghX");


var $9jl6v = parcelRequire("9jl6v");


var $8SCD6 = parcelRequire("8SCD6");


var $8i27m = parcelRequire("8i27m");


var $hd53J = parcelRequire("hd53J");


var $4L9ve = parcelRequire("4L9ve");


var $5fMeR = parcelRequire("5fMeR");


var $3mVfX = parcelRequire("3mVfX");


var $iNYtG = parcelRequire("iNYtG");


var $dJ5r4 = parcelRequire("dJ5r4");


var $fyPYm = parcelRequire("fyPYm");


var $5pQ1Y = parcelRequire("5pQ1Y");


var $jFm04 = parcelRequire("jFm04");


var $6pBXK = parcelRequire("6pBXK");





var $ep3mz = parcelRequire("ep3mz");


var $7QM6o = parcelRequire("7QM6o");


var $9sGCn = parcelRequire("9sGCn");


var $hSqtY = parcelRequire("hSqtY");


var $3IBnw = parcelRequire("3IBnw");


var $ln0hx = parcelRequire("ln0hx");


var $irVI7 = parcelRequire("irVI7");

/* Omnibar.tsx generated by @compiled/babel-plugin v2.0.0 */ 



var $kSwu1 = parcelRequire("kSwu1");





var $iMnC5 = parcelRequire("iMnC5");


var $1l0kj = parcelRequire("1l0kj");


var $w6R6I = parcelRequire("w6R6I");


var $ad7Ou = parcelRequire("ad7Ou");


var $1sCHt = parcelRequire("1sCHt");


var $7sJoX = parcelRequire("7sJoX");


var $j6vyT = parcelRequire("j6vyT");


var $cY2bA = parcelRequire("cY2bA");


var $lpNn5 = parcelRequire("lpNn5");


var $93Gae = parcelRequire("93Gae");


var $aOKRX = parcelRequire("aOKRX");


var $1eaCJ = parcelRequire("1eaCJ");





var $b0EGa = parcelRequire("b0EGa");


var $7W8i8 = parcelRequire("7W8i8");


var $1UApO = parcelRequire("1UApO");


var $17wUi = parcelRequire("17wUi");

/* OmnibarReactions.tsx generated by @compiled/babel-plugin v2.0.0 */ 









var $4ez2K = parcelRequire("4ez2K");





var $b35Wv = parcelRequire("b35Wv");


var $cK21K = parcelRequire("cK21K");


var $jp2Q3 = parcelRequire("jp2Q3");


var $kwzZh = parcelRequire("kwzZh");


var $lsxnT = parcelRequire("lsxnT");


var $1NF8X = parcelRequire("1NF8X");


var $3FlVr = parcelRequire("3FlVr");


var $bQm3c = parcelRequire("bQm3c");


var $32x2E = parcelRequire("32x2E");




const $387c7e4b79a2c2e2$var$i18n = (0, $kSwu1.defineMessages)({
    thumbsUp: {
        id: "experiment-omnibar.omni-bar.reaction.thumbsUp",
        defaultMessage: "Thumbs up"
    },
    clap: {
        id: "experiment-omnibar.omni-bar.reaction.clap",
        defaultMessage: "Clap"
    },
    fire: {
        id: "experiment-omnibar.omni-bar.reaction.fire",
        defaultMessage: "Fire"
    },
    heart: {
        id: "experiment-omnibar.omni-bar.reaction.heart",
        defaultMessage: "Heart"
    },
    astonished: {
        id: "experiment-omnibar.omni-bar.reaction.astonished",
        defaultMessage: "Astonished"
    }
});
const $387c7e4b79a2c2e2$export$f15a7d7a553aca16 = [
    {
        id: '1f44d',
        shortName: ':thumbsup:',
        fallback: "\uD83D\uDC4D",
        tooltipDescriptor: $387c7e4b79a2c2e2$var$i18n.thumbsUp
    },
    {
        id: '1f44f',
        shortName: ':clap:',
        fallback: "\uD83D\uDC4F",
        tooltipDescriptor: $387c7e4b79a2c2e2$var$i18n.clap
    },
    {
        id: '1f525',
        shortName: ':fire:',
        fallback: "\uD83D\uDD25",
        tooltipDescriptor: $387c7e4b79a2c2e2$var$i18n.fire
    },
    {
        id: '2764',
        shortName: ':heart:',
        fallback: "\u2764\uFE0F",
        tooltipDescriptor: $387c7e4b79a2c2e2$var$i18n.heart
    },
    {
        id: '1f632',
        shortName: ':astonished:',
        fallback: "\uD83D\uDE32",
        tooltipDescriptor: $387c7e4b79a2c2e2$var$i18n.astonished
    }
];
const $387c7e4b79a2c2e2$export$56912a632457f516 = 20;
const $387c7e4b79a2c2e2$export$d78bee0d9fab78ad = 16;
const $387c7e4b79a2c2e2$export$d3cbd516c71e2528 = (shortName)=>{
    return $387c7e4b79a2c2e2$export$f15a7d7a553aca16.find((reaction)=>reaction.shortName === shortName);
};
const $387c7e4b79a2c2e2$export$12e0bba3487fb7fd = (emojiId)=>{
    const config = $387c7e4b79a2c2e2$export$f15a7d7a553aca16.find((r)=>r.id === emojiId);
    return config?.shortName ?? `:emoji-${emojiId}:`;
};
const $387c7e4b79a2c2e2$export$274f4038c85e9fe5 = (shortName)=>{
    return shortName.replace(/^:/, '').replace(/:$/, '').split('_').map((word)=>word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
};


/* DefaultReactionButton.tsx generated by @compiled/babel-plugin v2.0.0 */ 












var $hBYtq = parcelRequire("hBYtq");











var $6OpMl = parcelRequire("6OpMl");


var $yuV6Z = parcelRequire("yuV6Z");





const $9773a79590870b2e$export$198be09030cc5890 = 'omnibar-bloom';
const $9773a79590870b2e$export$96c5409d0b98e3bf = (randomDrift, randomTilt, randomRotation, randomDistance)=>({
        animationName: $9773a79590870b2e$export$198be09030cc5890,
        bloomDrift: `${randomDrift}px`,
        bloomTilt: `${randomTilt}deg`,
        bloomRotation: `${randomRotation}deg`,
        bloomDistance: `${randomDistance}px`
    });


const $9db24e0dc1ddcbfa$export$673194083bf9485c = ()=>{
    const [animatingEmojis, setAnimatingEmojis] = (0, $cozmU.useState)([]);
    const animationIdRef = (0, $cozmU.useRef)(0);
    const animationTimersRef = (0, $cozmU.useRef)(new Set());
    (0, $cozmU.useEffect)(()=>{
        const timers = animationTimersRef.current;
        return ()=>{
            timers.forEach((timer)=>clearTimeout(timer));
            timers.clear();
        };
    }, []);
    const triggerBloomAnimation = (0, $cozmU.useCallback)((x, y, emojiId)=>{
        const animation = (0, $9773a79590870b2e$export$96c5409d0b98e3bf)((Math.random() - 0.5) * 100, (Math.random() - 0.5) * 30, (Math.random() - 0.5) * 40, -120 - Math.random() * 80);
        const id = ++animationIdRef.current;
        setAnimatingEmojis((prev)=>[
                ...prev,
                {
                    id: id,
                    x: x,
                    y: y,
                    emojiId: emojiId,
                    ...animation
                }
            ]);
        const timer = setTimeout(()=>{
            animationTimersRef.current.delete(timer);
            setAnimatingEmojis((prev)=>prev.filter((e)=>e.id !== id));
        }, 1300);
        animationTimersRef.current.add(timer);
    }, []);
    return {
        animatingEmojis: animatingEmojis,
        triggerBloomAnimation: triggerBloomAnimation
    };
};


/* BloomAnimationEmoji.tsx generated by @compiled/babel-plugin v2.0.0 */ /* eslint-disable @compiled/no-keyframes-tagged-template-expression, @atlaskit/design-system/no-keyframes-tagged-template-expression, @atlaskit/ui-styling-standard/no-unsafe-values */ 









const $806badad5c4e8903$var$bloomKeyframes = null;
const $806badad5c4e8903$var$styles = {
    bloomContainer: "_1mT5xdy1CL _1VJPcaiDnZ _1pp6NdYbGa _1gBibylz32 _0nFVCGZ1wv _43vdfTHBJp _3Y6bKpgRhm _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT"
};
const $806badad5c4e8903$var$BloomAnimationEmojiInner = ({ animatingEmoji: animatingEmoji, emojiProvider: emojiProvider, emojiSize: emojiSize = (0, $387c7e4b79a2c2e2$export$d78bee0d9fab78ad) })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $806badad5c4e8903$var$styles.bloomContainer,
        style: {
            left: `${animatingEmoji.x}px`,
            top: `${animatingEmoji.y}px`,
            '--bloom-drift': animatingEmoji.bloomDrift,
            '--bloom-tilt': animatingEmoji.bloomTilt,
            '--bloom-rotation': animatingEmoji.bloomRotation,
            '--bloom-distance': animatingEmoji.bloomDistance
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6OpMl.default), {
        emojiProvider: emojiProvider,
        emojiId: {
            id: animatingEmoji.emojiId,
            shortName: ''
        },
        showTooltip: false,
        fitToHeight: emojiSize
    }));
};
const $806badad5c4e8903$export$8f2cbc3d71d39c12 = /*#__PURE__*/ (0, $cozmU.memo)($806badad5c4e8903$var$BloomAnimationEmojiInner);
$806badad5c4e8903$export$8f2cbc3d71d39c12.displayName = 'BloomAnimationEmoji';


const $12725042cedb1af2$var$OMNIBAR_ANALYTICS_SOURCE = 'confluenceOmniBar';
const $12725042cedb1af2$var$HOVER_TILT_MIN_DEG = -15;
const $12725042cedb1af2$var$HOVER_TILT_MAX_DEG = 15;
const $12725042cedb1af2$var$HOVER_LIFT_PX = 15;
const $12725042cedb1af2$var$HOVER_SCALE = 1.8;
function $12725042cedb1af2$var$getRandomHoverTilt() {
    return Math.floor(Math.random() * ($12725042cedb1af2$var$HOVER_TILT_MAX_DEG - $12725042cedb1af2$var$HOVER_TILT_MIN_DEG + 1)) + $12725042cedb1af2$var$HOVER_TILT_MIN_DEG;
}
const $12725042cedb1af2$var$styles = {
    emojiButton: "_313842dnbC _0adFHsdnbC _1DCdHidnbC _2XsHFMdnbC _30huDKYbGa _0bjKvDKxmn _4bt5LAYvD1 _2WAcuGYvD1 _4c065UgVvo _2Y7lL4gVvo _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _0adFHs2ADO _39xV02Uofl _4ouGXIUofl _0jFU0VUofl _3YEZNOdnbC _1pp6NdIZbP _0KLXrujOvk",
    emojiInnerContainer: "_4bt5LAYvD1 _2WAcuGYvD1 _23rrnHCtpv _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _0KLXrujOvk _39xV02N91d _0jFU0VN91d",
    tooltipTriggerWrapper: "_4bt5LAYvD1 _2WAcuGYvD1 _46hvQm5zaO _43nrzTUgYP _3iDTPbvbI6"
};
const $12725042cedb1af2$var$DefaultReactionButtonInner = ({ emojiId: emojiId, emojiProvider: emojiProvider, cloudId: cloudId, reacted: reacted, onClick: onClick, tooltipDescriptor: tooltipDescriptor })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { animatingEmojis: animatingEmojis, triggerBloomAnimation: triggerBloomAnimation } = (0, $9db24e0dc1ddcbfa$export$673194083bf9485c)();
    const [isTooltipVisible, setIsTooltipVisible] = (0, $cozmU.useState)(true);
    const [isHovered, setIsHovered] = (0, $cozmU.useState)(false);
    const [hoverTilt, setHoverTilt] = (0, $cozmU.useState)(0);
    const emojiHoverTransform = isHovered ? `translateY(-${$12725042cedb1af2$var$HOVER_LIFT_PX}px) scale(${$12725042cedb1af2$var$HOVER_SCALE}) rotate(${hoverTilt}deg)` : 'translateY(0) scale(1) rotate(0deg)';
    const handleClick = (0, $cozmU.useCallback)((event)=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'omniBarEmojiSlot',
                source: $12725042cedb1af2$var$OMNIBAR_ANALYTICS_SOURCE,
                attributes: {
                    emojiId: emojiId.id || ''
                }
            }
        }).fire();
        setIsTooltipVisible(false);
        setIsHovered(false);
        const rect = event.currentTarget.getBoundingClientRect();
        const x = rect.left + rect.width / 2 - 10;
        const y = rect.top + rect.height / 2 - 20;
        triggerBloomAnimation(x, y, emojiId.id || '');
        if (!reacted && onClick) onClick();
    }, [
        onClick,
        emojiId.id,
        reacted,
        triggerBloomAnimation,
        createAnalyticsEvent
    ]);
    const handleMouseEnter = (0, $cozmU.useCallback)(()=>{
        setIsTooltipVisible(true);
        setHoverTilt($12725042cedb1af2$var$getRandomHoverTilt());
        setIsHovered(true);
    }, []);
    const handleMouseLeave = (0, $cozmU.useCallback)(()=>{
        setIsHovered(false);
    }, []);
    const handleFocus = (0, $cozmU.useCallback)(()=>{
        setIsTooltipVisible(true);
    }, []);
    const ariaLabel = tooltipDescriptor ? formatMessage(tooltipDescriptor) : undefined;
    const button = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
        onClick: handleClick,
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave,
        onFocus: handleFocus,
        xcss: $12725042cedb1af2$var$styles.emojiButton,
        "aria-label": ariaLabel
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $12725042cedb1af2$var$styles.emojiInnerContainer,
        style: {
            transform: emojiHoverTransform
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6OpMl.default), {
        emojiProvider: emojiProvider,
        emojiId: emojiId,
        showTooltip: false,
        fitToHeight: (0, $387c7e4b79a2c2e2$export$56912a632457f516),
        optimisticImageURL: cloudId && emojiId.id ? (0, $yuV6Z.getOptimisticImageURL)(cloudId, emojiId.id, 'MDPI') : undefined
    })));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, ariaLabel && isTooltipVisible ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
        content: ariaLabel,
        position: "top"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $12725042cedb1af2$var$styles.tooltipTriggerWrapper
    }, button)) : button, typeof document !== 'undefined' && animatingEmojis.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cK21K.default), {
        zIndex: (0, $jp2Q3.layers).spotlight()
    }, animatingEmojis.map((animatingEmoji)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $806badad5c4e8903$export$8f2cbc3d71d39c12), {
            key: animatingEmoji.id,
            animatingEmoji: animatingEmoji,
            emojiProvider: emojiProvider,
            emojiSize: (0, $387c7e4b79a2c2e2$export$56912a632457f516)
        }))));
};
const $12725042cedb1af2$export$98b42579a0c01f69 = /*#__PURE__*/ (0, $cozmU.memo)($12725042cedb1af2$var$DefaultReactionButtonInner);
$12725042cedb1af2$export$98b42579a0c01f69.displayName = 'DefaultReactionButton';


/* ReactionSummaryPopup.tsx generated by @compiled/babel-plugin v2.0.0 */ 









var $j72ee = parcelRequire("j72ee");


var $iODl6 = parcelRequire("iODl6");





var $j2uPw = parcelRequire("j2uPw");








const $559fbabe644a799b$var$styles = {
    loadingCounterPlaceholder: "_0bjKvDKxmn _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _0KLXru66of _39xV02oWWg _0jFU0VEbN9",
    loadingEmojiPlaceholder: "_0bjKvDKxmn _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _0KLXru66of _39xV02ey7F _0jFU0Vey7F",
    emojiContainer: "_3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _39xV02ey7F _0jFU0Vey7F",
    popupContent: "_4c065U2ADO _2Y7lL42ADO _39xV02E6Kk",
    counterContainer: "_4bt5LAnQyn _2WAcuGnQyn _1mT5xdRAKS _4zgPmfbiPq"
};
const $559fbabe644a799b$var$reactionsGridStyles = {
    grid: "_2mHwu81Y8M _3iDTPbkfkE _0hPCNLDIqT _2iEGP2f4U9"
};
const $559fbabe644a799b$var$EmojiItemInner = ({ emojiId: emojiId, emojiProvider: emojiProvider, cloudId: cloudId })=>{
    const emojiIdObj = (0, $cozmU.useMemo)(()=>({
            id: emojiId,
            shortName: (0, $387c7e4b79a2c2e2$export$12e0bba3487fb7fd)(emojiId)
        }), [
        emojiId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $559fbabe644a799b$var$styles.emojiContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6OpMl.default), {
        emojiProvider: emojiProvider,
        emojiId: emojiIdObj,
        fitToHeight: (0, $387c7e4b79a2c2e2$export$d78bee0d9fab78ad),
        showTooltip: false,
        optimisticImageURL: cloudId ? (0, $yuV6Z.getOptimisticImageURL)(cloudId, emojiId, 'MDPI') : undefined
    }));
};
const $559fbabe644a799b$var$EmojiItem = /*#__PURE__*/ (0, $cozmU.memo)($559fbabe644a799b$var$EmojiItemInner);
const $559fbabe644a799b$var$EmojiList = ({ isLoading: isLoading, topReactions: topReactions, emojiProvider: emojiProvider, cloudId: cloudId })=>{
    if (isLoading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $559fbabe644a799b$var$styles.loadingEmojiPlaceholder
    });
    if (topReactions.length === 0) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.025"
    }, topReactions.map((reaction)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($559fbabe644a799b$var$EmojiItem, {
            key: reaction.emojiId,
            emojiId: reaction.emojiId,
            emojiProvider: emojiProvider,
            cloudId: cloudId
        })));
};
const $559fbabe644a799b$var$formatNumber = (num)=>{
    if (num === 0) return '';
    if (num >= 1000) return `${(num / 1000).toFixed(1)}k+`;
    return num.toString();
};
const $559fbabe644a799b$var$Counter = ({ isLoading: isLoading, totalCount: totalCount })=>{
    const previousValueRef = (0, $cozmU.useRef)(undefined);
    (0, $cozmU.useEffect)(()=>{
        previousValueRef.current = totalCount;
    }, [
        totalCount
    ]);
    const isIncreasing = (0, $cozmU.useMemo)(()=>previousValueRef.current !== undefined && previousValueRef.current < totalCount, [
        totalCount
    ]);
    if (isLoading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $559fbabe644a799b$var$styles.loadingCounterPlaceholder
    });
    if (totalCount === 0) return null;
    const label = $559fbabe644a799b$var$formatNumber(totalCount);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $559fbabe644a799b$var$styles.counterContainer,
        testId: "omni-bar-reaction-counter"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iODl6.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $j72ee.default), {
        enterFrom: isIncreasing ? 'top' : 'bottom',
        exitTo: isIncreasing ? 'top' : 'bottom',
        key: totalCount,
        duration: "medium"
    }, (motion, direction)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            ref: motion.ref,
            style: {
                position: direction === 'exiting' ? 'absolute' : undefined
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
            className: motion.className
        }, label))));
};
const $559fbabe644a799b$var$ReactionSummaryTriggerInner = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).forwardRef(({ isOpen: isOpen, isLoading: isLoading, totalCount: totalCount, topReactions: topReactions, emojiProvider: emojiProvider, onClick: onClick, cloudId: cloudId }, ref)=>{
    const handleClick = (0, $cozmU.useCallback)(()=>{
        if (!isLoading && totalCount > 0) onClick();
    }, [
        isLoading,
        totalCount,
        onClick
    ]);
    const iconContent = (0, $cozmU.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($559fbabe644a799b$var$EmojiList, {
            isLoading: isLoading,
            topReactions: topReactions,
            emojiProvider: emojiProvider,
            cloudId: cloudId
        }), [
        isLoading,
        topReactions,
        emojiProvider,
        cloudId
    ]);
    const renderIcon = (0, $cozmU.useCallback)(()=>iconContent, [
        iconContent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        ref: ref,
        appearance: "subtle",
        onClick: handleClick,
        isSelected: isOpen,
        testId: "omni-bar-reaction-summary-trigger",
        iconBefore: renderIcon
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($559fbabe644a799b$var$Counter, {
        isLoading: isLoading,
        totalCount: totalCount
    }));
});
const $559fbabe644a799b$export$46b9d6923ba2ba99 = /*#__PURE__*/ (0, $cozmU.memo)($559fbabe644a799b$var$ReactionSummaryTriggerInner);
$559fbabe644a799b$export$46b9d6923ba2ba99.displayName = 'ReactionSummaryTrigger';
const $559fbabe644a799b$var$MAX_COLUMNS = 5;
const $559fbabe644a799b$export$49a38d37ed252373 = ({ reactions: reactions, emojiProvider: emojiProvider, onReactionClick: onReactionClick })=>{
    const columnCount = Math.min(reactions.length, $559fbabe644a799b$var$MAX_COLUMNS);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $559fbabe644a799b$var$styles.popupContent,
        testId: "omni-bar-reaction-summary-popup"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $559fbabe644a799b$var$reactionsGridStyles.grid,
        style: {
            '--reaction-column-count': columnCount
        }
    }, reactions.map((reaction)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $j2uPw.Reaction), {
            key: reaction.emojiId,
            reaction: reaction,
            emojiProvider: emojiProvider,
            onClick: onReactionClick,
            allowUserDialog: false,
            isViewOnly: false
        }))));
};


/**
 * @generated SignedSource<<c5b32a8810f21edc49b0aa8cedc1c2c6>>
 * @relayHash 534f8e942a7a9be603c661094407bcec
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e2c330cfe2a389ef29d4dca6873b21df3ce63ab4c4dfd32740a35e137109512b
const $6da456df757dd22d$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "containerId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "containerType"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentType"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "emojiId"
    }, v6 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                },
                {
                    "fields": [
                        {
                            "kind": "Variable",
                            "name": "containerId",
                            "variableName": "containerId"
                        },
                        {
                            "kind": "Variable",
                            "name": "containerType",
                            "variableName": "containerType"
                        },
                        {
                            "kind": "Variable",
                            "name": "contentId",
                            "variableName": "contentId"
                        },
                        {
                            "kind": "Variable",
                            "name": "contentType",
                            "variableName": "contentType"
                        },
                        {
                            "kind": "Variable",
                            "name": "emojiId",
                            "variableName": "emojiId"
                        }
                    ],
                    "kind": "ObjectValue",
                    "name": "input"
                }
            ],
            "concreteType": "ConfluenceReactionPayload",
            "kind": "LinkedField",
            "name": "confluence_deleteReaction",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "ari"
                },
                {
                    "kind": "ScalarField",
                    "name": "containerAri"
                },
                {
                    "kind": "ScalarField",
                    "name": "emojiId"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useReactionMutationsDeleteReactionMutation",
            "selections": v6 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v3 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "useReactionMutationsDeleteReactionMutation",
            "selections": v6 /*: any*/ 
        },
        "params": {
            "cacheID": "534f8e942a7a9be603c661094407bcec",
            "id": "e2c330cfe2a389ef29d4dca6873b21df3ce63ab4c4dfd32740a35e137109512b",
            "metadata": {},
            "name": "useReactionMutationsDeleteReactionMutation",
            "operationKind": "mutation",
            "text": "mutation useReactionMutationsDeleteReactionMutation($cloudId:ID!,$contentId:Long!,$containerId:Long!,$containerType:ContainerType!,$contentType:GraphQLReactionContentType!,$emojiId:String!){confluence_deleteReaction(cloudId:$cloudId,input:{contentId:$contentId,containerId:$containerId,containerType:$containerType,contentType:$contentType,emojiId:$emojiId}){ari,containerAri,emojiId}}"
        }
    };
}();
$6da456df757dd22d$var$node.hash = "026dd0e0d892c04c9adf5d33242807f3";
var $6da456df757dd22d$export$2e2bcd8739ae039 = $6da456df757dd22d$var$node;


/**
 * @generated SignedSource<<895e638438fbcf649a5d5b9d85af4c18>>
 * @relayHash 4a2a6e866128a40badb1b2179a63d891
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 1ba1e6729b66fc8b622f7a36d5173c8b3e342d9660af111d7f0224ce90bfb455
const $81fdb6060c63d896$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "containerId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "containerType"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentType"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "emojiId"
    }, v6 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                },
                {
                    "fields": [
                        {
                            "kind": "Variable",
                            "name": "containerId",
                            "variableName": "containerId"
                        },
                        {
                            "kind": "Variable",
                            "name": "containerType",
                            "variableName": "containerType"
                        },
                        {
                            "kind": "Variable",
                            "name": "contentId",
                            "variableName": "contentId"
                        },
                        {
                            "kind": "Variable",
                            "name": "contentType",
                            "variableName": "contentType"
                        },
                        {
                            "kind": "Variable",
                            "name": "emojiId",
                            "variableName": "emojiId"
                        }
                    ],
                    "kind": "ObjectValue",
                    "name": "input"
                }
            ],
            "concreteType": "ConfluenceReactionPayload",
            "kind": "LinkedField",
            "name": "confluence_addReaction",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "ari"
                },
                {
                    "kind": "ScalarField",
                    "name": "containerAri"
                },
                {
                    "kind": "ScalarField",
                    "name": "emojiId"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useReactionMutationsAddReactionMutation",
            "selections": v6 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v3 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "useReactionMutationsAddReactionMutation",
            "selections": v6 /*: any*/ 
        },
        "params": {
            "cacheID": "4a2a6e866128a40badb1b2179a63d891",
            "id": "1ba1e6729b66fc8b622f7a36d5173c8b3e342d9660af111d7f0224ce90bfb455",
            "metadata": {},
            "name": "useReactionMutationsAddReactionMutation",
            "operationKind": "mutation",
            "text": "mutation useReactionMutationsAddReactionMutation($cloudId:ID!,$contentId:Long!,$containerId:Long!,$containerType:ContainerType!,$contentType:GraphQLReactionContentType!,$emojiId:String!){confluence_addReaction(cloudId:$cloudId,input:{contentId:$contentId,containerId:$containerId,containerType:$containerType,contentType:$contentType,emojiId:$emojiId}){ari,containerAri,emojiId}}"
        }
    };
}();
$81fdb6060c63d896$var$node.hash = "547036fa0d9c77c600330473576f635a";
var $81fdb6060c63d896$export$2e2bcd8739ae039 = $81fdb6060c63d896$var$node;









var $308Wd = parcelRequire("308Wd");


var $8wyJO = parcelRequire("8wyJO");


var $5qhgL = parcelRequire("5qhgL");








var $fGzMp = parcelRequire("fGzMp");





var $l1uFv = parcelRequire("l1uFv");


var $fEmGS = parcelRequire("fEmGS");

const $57464ea87c3c7fcd$var$logger = (0, $7W8i8.getLogger)('omnibar-reactions');
const $57464ea87c3c7fcd$var$useReactionMutationsAddReactionMutation = (0, $81fdb6060c63d896$export$2e2bcd8739ae039);
const $57464ea87c3c7fcd$var$useReactionMutationsDeleteReactionMutation = (0, $6da456df757dd22d$export$2e2bcd8739ae039);
/** Optimistic response for add reaction (matches useReactionMutationsAddReactionMutation$data). */ const $57464ea87c3c7fcd$var$createAddReactionOptimisticResponse = (emojiId)=>({
        __typename: 'Mutation',
        confluence_addReaction: {
            __typename: 'ConfluenceReactionPayload',
            ari: null,
            containerAri: null,
            emojiId: emojiId
        }
    });
/** Optimistic response for delete reaction (matches useReactionMutationsDeleteReactionMutation$data). */ const $57464ea87c3c7fcd$var$createDeleteReactionOptimisticResponse = (emojiId)=>({
        __typename: 'Mutation',
        confluence_deleteReaction: {
            __typename: 'ConfluenceReactionPayload',
            ari: null,
            containerAri: null,
            emojiId: emojiId
        }
    });
/**
 * Gets updated reactions response for cache update.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
const $57464ea87c3c7fcd$var$getUpdatedReactionsResponse = (data, emojiId, actionType, isComment)=>{
    const summary = (0, $8wyJO.getReactionsSummary)(data);
    if (!summary) return;
    let updatedCount = summary.reactionsCount ?? 0;
    const updatedReactions = [
        ...summary.reactionsSummaryForEmoji ?? []
    ];
    const reactionObject = updatedReactions.find((item)=>item?.emojiId === emojiId);
    if (actionType === 'add') {
        if (reactionObject && !reactionObject.reacted) {
            const idx = updatedReactions.indexOf(reactionObject);
            updatedReactions[idx] = {
                ...reactionObject,
                count: (reactionObject.count ?? 0) + 1,
                reacted: true
            };
        } else updatedReactions.push({
            emojiId: emojiId,
            count: 1,
            reacted: true,
            id: `${summary.containerAri}|${summary.ari}|${emojiId}`,
            __typename: 'ReactionsSummaryForEmoji'
        });
        updatedCount++;
    }
    if (actionType === 'delete') {
        if (reactionObject && reactionObject.reacted && (reactionObject.count ?? 0) > 1) {
            const idx = updatedReactions.indexOf(reactionObject);
            updatedReactions[idx] = {
                ...reactionObject,
                count: (reactionObject.count ?? 0) - 1,
                reacted: false
            };
        } else {
            const removeIdx = updatedReactions.map((item)=>item?.emojiId).indexOf(emojiId);
            updatedReactions.splice(removeIdx, 1);
        }
        updatedCount--;
    }
    const getContentResponseData = ()=>({
            ...data,
            content: {
                ...data.content,
                nodes: [
                    {
                        ...data.content.nodes[0],
                        contentReactionsSummary: {
                            ...summary,
                            reactionsSummaryForEmoji: updatedReactions,
                            reactionsCount: updatedCount
                        }
                    }
                ]
            }
        });
    return isComment ? {
        ...data,
        comments: {
            ...data.comments,
            nodes: [
                {
                    ...data.comments.nodes[0],
                    reactionsSummary: {
                        ...summary,
                        reactionsSummaryForEmoji: updatedReactions,
                        reactionsCount: updatedCount
                    }
                }
            ]
        }
    } : getContentResponseData();
};
const $57464ea87c3c7fcd$export$c666d2c09581fced = ({ contentId: contentId, spaceId: spaceId, contentType: contentType, contentSubType: contentSubType, cloudId: cloudId, edition: edition, reactionsMap: reactionsMap })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const activeReactionsRef = (0, $cozmU.useRef)(new Set());
    const { isComment: isComment } = (0, $5qhgL.getBooleanLocationTypes)(contentType);
    const [addReaction] = (0, $308Wd.useMutationInterop)($57464ea87c3c7fcd$var$useReactionMutationsAddReactionMutation, {
        __callerPackage__: "experiment-omnibar"
    });
    const [deleteReaction] = (0, $308Wd.useMutationInterop)($57464ea87c3c7fcd$var$useReactionMutationsDeleteReactionMutation, {
        __callerPackage__: "experiment-omnibar"
    });
    const updateApolloCache = (0, $cozmU.useCallback)((emojiId, actionType)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
        (_cache, result)=>{
            if (!result) return;
            const { query: query, queryVariables: queryVariables } = (0, $8wyJO.getReactionsQueryInfo)(isComment, contentId, spaceId);
            try {
                const response = (0, $l1uFv.readQueryInterop)({
                    query: query,
                    variables: queryVariables,
                    __callerPackage__: "experiment-omnibar"
                });
                const updatedResponse = $57464ea87c3c7fcd$var$getUpdatedReactionsResponse(response, emojiId, actionType, isComment);
                if (updatedResponse) (0, $fEmGS.writeQueryInterop)({
                    query: query,
                    variables: queryVariables,
                    data: updatedResponse,
                    __callerPackage__: "experiment-omnibar"
                });
            } catch (err) {
                $57464ea87c3c7fcd$var$logger.error`An error occurred when updating cache for omnibar reaction - ${err}`;
            }
        }, [
        contentId,
        spaceId,
        isComment
    ]);
    const handleDefaultReactionClick = (0, $cozmU.useCallback)((emojiId)=>{
        if (activeReactionsRef.current.has(emojiId)) return;
        const existingReaction = reactionsMap.get(emojiId);
        if (existingReaction?.reacted) return;
        if (!cloudId || !contentId || !spaceId || !contentType) return;
        activeReactionsRef.current.add(emojiId);
        const experienceTracker = (0, $fGzMp.getExperienceTracker)();
        experienceTracker.start({
            name: (0, $irVI7.OMNIBAR_ADD_REACTION_EXPERIENCE),
            attributes: {
                contentId: contentId,
                contentType: contentType,
                emojiId: emojiId,
                placement: 'omni-bar'
            }
        });
        addReaction({
            variables: {
                cloudId: cloudId || '',
                contentId: Number(contentId),
                contentType: contentType?.toUpperCase(),
                containerId: Number(spaceId),
                containerType: (0, $3FlVr.ReactionContainerType).SPACE.toUpperCase(),
                emojiId: emojiId
            },
            update: updateApolloCache(emojiId, 'add'),
            optimisticResponse: $57464ea87c3c7fcd$var$createAddReactionOptimisticResponse(emojiId)
        }).then(()=>{
            activeReactionsRef.current.delete(emojiId);
            experienceTracker.succeed({
                name: (0, $irVI7.OMNIBAR_ADD_REACTION_EXPERIENCE)
            });
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    action: 'created',
                    actionSubject: 'reaction',
                    source: contentType,
                    attributes: {
                        objectId: contentId,
                        objectType: contentType,
                        containerId: spaceId,
                        containerType: (0, $3FlVr.ReactionContainerType).SPACE,
                        emojiId: emojiId,
                        displayType: contentType,
                        isLivePage: contentSubType === 'live',
                        reactionsPlacement: 'omni-bar',
                        edition: edition
                    }
                }
            }).fire();
        }).catch((error)=>{
            activeReactionsRef.current.delete(emojiId);
            $57464ea87c3c7fcd$var$logger.error`Failed to add reaction in omnibar: ${error}`;
            experienceTracker.stopOnError({
                name: (0, $irVI7.OMNIBAR_ADD_REACTION_EXPERIENCE),
                error: error instanceof Error ? error : new Error(String(error))
            });
        });
    }, [
        reactionsMap,
        addReaction,
        cloudId,
        contentId,
        contentType,
        spaceId,
        updateApolloCache,
        createAnalyticsEvent,
        contentSubType,
        edition
    ]);
    const handleSummaryReactionClick = (0, $cozmU.useCallback)((emojiId)=>{
        if (activeReactionsRef.current.has(emojiId)) return;
        if (!cloudId || !contentId || !spaceId || !contentType) return;
        const existingReaction = reactionsMap.get(emojiId);
        const experienceTracker = (0, $fGzMp.getExperienceTracker)();
        if (!existingReaction?.reacted) {
            activeReactionsRef.current.add(emojiId);
            experienceTracker.start({
                name: (0, $irVI7.OMNIBAR_ADD_REACTION_EXPERIENCE),
                attributes: {
                    contentId: contentId,
                    contentType: contentType,
                    emojiId: emojiId,
                    placement: 'omni-bar-summary'
                }
            });
            addReaction({
                variables: {
                    cloudId: cloudId || '',
                    contentId: Number(contentId),
                    contentType: contentType?.toUpperCase(),
                    containerId: Number(spaceId),
                    containerType: (0, $3FlVr.ReactionContainerType).SPACE.toUpperCase(),
                    emojiId: emojiId
                },
                update: updateApolloCache(emojiId, 'add'),
                optimisticResponse: $57464ea87c3c7fcd$var$createAddReactionOptimisticResponse(emojiId)
            }).then(()=>{
                activeReactionsRef.current.delete(emojiId);
                experienceTracker.succeed({
                    name: (0, $irVI7.OMNIBAR_ADD_REACTION_EXPERIENCE)
                });
            }).catch((error)=>{
                activeReactionsRef.current.delete(emojiId);
                $57464ea87c3c7fcd$var$logger.error`Failed to add reaction from summary in omnibar: ${error}`;
                experienceTracker.stopOnError({
                    name: (0, $irVI7.OMNIBAR_ADD_REACTION_EXPERIENCE),
                    error: error instanceof Error ? error : new Error(String(error))
                });
            });
            return;
        }
        activeReactionsRef.current.add(emojiId);
        experienceTracker.start({
            name: (0, $irVI7.OMNIBAR_DELETE_REACTION_EXPERIENCE),
            attributes: {
                contentId: contentId,
                contentType: contentType,
                emojiId: emojiId,
                placement: 'omni-bar-summary'
            }
        });
        deleteReaction({
            variables: {
                cloudId: cloudId || '',
                contentId: Number(contentId),
                contentType: contentType?.toUpperCase(),
                containerId: Number(spaceId),
                containerType: (0, $3FlVr.ReactionContainerType).SPACE.toUpperCase(),
                emojiId: emojiId
            },
            update: updateApolloCache(emojiId, 'delete'),
            optimisticResponse: $57464ea87c3c7fcd$var$createDeleteReactionOptimisticResponse(emojiId)
        }).then(()=>{
            activeReactionsRef.current.delete(emojiId);
            experienceTracker.succeed({
                name: (0, $irVI7.OMNIBAR_DELETE_REACTION_EXPERIENCE)
            });
        }).catch((error)=>{
            activeReactionsRef.current.delete(emojiId);
            $57464ea87c3c7fcd$var$logger.error`Failed to delete reaction in omnibar: ${error}`;
            experienceTracker.stopOnError({
                name: (0, $irVI7.OMNIBAR_DELETE_REACTION_EXPERIENCE),
                error: error instanceof Error ? error : new Error(String(error))
            });
        });
    }, [
        addReaction,
        deleteReaction,
        cloudId,
        contentId,
        contentType,
        spaceId,
        reactionsMap,
        updateApolloCache
    ]);
    return {
        handleDefaultReactionClick: handleDefaultReactionClick,
        handleSummaryReactionClick: handleSummaryReactionClick
    };
};





const $c49579fe5d161c4c$var$PICKER_SELECTOR = '[data-emoji-picker-container]';
const $c49579fe5d161c4c$export$677c63a231082721 = ()=>{
    const [isEmojiPickerOpen, setIsEmojiPickerOpen] = (0, $cozmU.useState)(false);
    const debounceFrameIdRef = (0, $cozmU.useRef)(null);
    const pollFrameIdRef = (0, $cozmU.useRef)(null);
    const observerRef = (0, $cozmU.useRef)(null);
    const isOpenRef = (0, $cozmU.useRef)(false);
    (0, $cozmU.useEffect)(()=>{
        if (typeof document === 'undefined' || typeof window === 'undefined') return;
        let idleCallbackId = null;
        let isMounted = true;
        const checkPickerOpen = ()=>{
            const pickerElement = document.querySelector($c49579fe5d161c4c$var$PICKER_SELECTOR);
            return pickerElement !== null;
        };
        const updateState = (isOpen)=>{
            // Only update state if component is still mounted and state actually changed
            if (!isMounted) return;
            if (isOpenRef.current !== isOpen) {
                isOpenRef.current = isOpen;
                setIsEmojiPickerOpen(isOpen);
            }
        };
        const startPolling = ()=>{
            if (pollFrameIdRef.current !== null) return; // Already polling
            const poll = ()=>{
                // Guard: don't continue if component unmounted
                if (!isMounted || pollFrameIdRef.current === null) return;
                const stillOpen = checkPickerOpen();
                updateState(stillOpen);
                if (!stillOpen) {
                    // Picker closed, stop polling and reconnect observer
                    pollFrameIdRef.current = null;
                    if (isMounted && observerRef.current) observerRef.current.observe(document.body, {
                        childList: true,
                        subtree: true
                    });
                } else if (isMounted) pollFrameIdRef.current = window.requestAnimationFrame(poll);
            };
            pollFrameIdRef.current = window.requestAnimationFrame(poll);
        };
        const stopPolling = ()=>{
            if (pollFrameIdRef.current !== null) {
                window.cancelAnimationFrame(pollFrameIdRef.current);
                pollFrameIdRef.current = null;
            }
        };
        const debouncedCheck = ()=>{
            if (debounceFrameIdRef.current === null) debounceFrameIdRef.current = window.requestAnimationFrame(()=>{
                // Guard: don't process if component unmounted
                if (!isMounted) {
                    debounceFrameIdRef.current = null;
                    return;
                }
                const isOpen = checkPickerOpen();
                updateState(isOpen);
                // If picker just opened and we're observing, switch to polling
                if (isOpen && isMounted && observerRef.current && pollFrameIdRef.current === null) {
                    observerRef.current.disconnect();
                    startPolling();
                }
                debounceFrameIdRef.current = null;
            });
        };
        const setupObserver = ()=>{
            observerRef.current = new MutationObserver((mutations)=>{
                const hasRelevantChanges = mutations.some((mutation)=>{
                    if (mutation.type !== 'childList') return false;
                    return mutation.addedNodes.length > 0 || mutation.removedNodes.length > 0;
                });
                if (hasRelevantChanges) debouncedCheck();
            });
            const isOpen = checkPickerOpen();
            updateState(isOpen);
            if (isOpen) startPolling();
            else observerRef.current.observe(document.body, {
                childList: true,
                subtree: true
            });
        };
        if (typeof window !== 'undefined' && 'requestIdleCallback' in window) idleCallbackId = window.requestIdleCallback(()=>setupObserver(), {
            timeout: 200
        });
        else idleCallbackId = setTimeout(setupObserver, 50);
        return ()=>{
            isMounted = false;
            if (debounceFrameIdRef.current !== null) {
                window.cancelAnimationFrame(debounceFrameIdRef.current);
                debounceFrameIdRef.current = null;
            }
            stopPolling();
            if (observerRef.current) {
                observerRef.current.disconnect();
                observerRef.current = null;
            }
            if (idleCallbackId !== null) {
                if (typeof window !== 'undefined' && 'cancelIdleCallback' in window && typeof idleCallbackId === 'number') window.cancelIdleCallback(idleCallbackId);
                else clearTimeout(idleCallbackId);
            }
        };
    }, []);
    return isEmojiPickerOpen;
};




const $95d3cc090e2e45a6$var$DEFAULT_EMOJI_COUNT = 5;
const $95d3cc090e2e45a6$var$OMNIBAR_ANALYTICS_SOURCE = 'confluenceOmniBar';
const $95d3cc090e2e45a6$var$i18n = (0, $kSwu1.defineMessages)({
    addReaction: {
        id: "experiment-omnibar.reactions.more-reactions",
        defaultMessage: "More reactions"
    }
});
const $95d3cc090e2e45a6$var$styles = {
    reactionsContainer: "_2mHwu8dnbC _0bjKvDKxmn _4bt5LAYvD1 _2WAcuGYvD1 _3iDTPbQ4SZ _0hPCNLDIqT _39xV02IZbP _4ouGXIGNMc _0jFU0VUofl _37wbyuchRC _3YEZNOdnbC _1pp6NdIZbP",
    emojiPickerWrapper: "_3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _3YEZNOdnbC _39xV02Uofl _0jFU0VUofl _1pp6NdIZbP",
    separator: "_39xV02HZdu _4ouGXIHZdu _0jFU0VoWWg _2XsHFM2ADO _0adFHs2ADO _3YEZNOdnbC _4xdlr0DIqT _3iDTPbvLZJ",
    summaryContainer: "_3iDTPbQ4SZ _0hPCNLDIqT _0jFU0VUofl _1pp6NdIZbP"
};
const $95d3cc090e2e45a6$var$SEPARATOR_BORDER_STYLE = {
    borderLeft: `${"var(--ds-border-width, 1px)"} solid ${"var(--ds-border, #0B120E24)"}`
};
const $95d3cc090e2e45a6$var$DEFAULT_EMOJI_IDS = new Set((0, $387c7e4b79a2c2e2$export$f15a7d7a553aca16).map((e)=>e.id));
const $95d3cc090e2e45a6$var$EMPTY_QUICK_REACTION_IDS = [];
const $95d3cc090e2e45a6$var$createReactionsMap = (reactions)=>{
    const map = new Map();
    reactions?.forEach((reaction)=>{
        map.set(reaction.emojiId, reaction);
    });
    return map;
};
const $95d3cc090e2e45a6$var$getTopReactions = (reactions, count = 3)=>{
    if (!reactions) return [];
    const reactionsWithCount = reactions.filter((reaction)=>reaction.count > 0);
    const sorted = [
        ...reactionsWithCount
    ].sort((a, b)=>b.count - a.count);
    return sorted.slice(0, count);
};
const $95d3cc090e2e45a6$var$convertToReactionSummaries = (reactions, spaceId, contentId)=>{
    if (!reactions) return [];
    const result = [];
    for (const reaction of reactions)if (reaction.count > 0) result.push({
        emojiId: reaction.emojiId,
        count: reaction.count,
        reacted: reaction.reacted || false,
        ari: reaction.ari || `${spaceId}|${contentId}|${reaction.emojiId}`,
        containerAri: reaction.containerAri || spaceId || ''
    });
    return result;
};
const $95d3cc090e2e45a6$var$OmniBarReactionsInner = ({ contentId: contentId, spaceId: spaceId, contentType: contentType, contentSubType: contentSubType, emojiCount: emojiCount = $95d3cc090e2e45a6$var$DEFAULT_EMOJI_COUNT, reactionsData: reactionsData, isLoading: isLoading = false, shouldCloseInteractions: shouldCloseInteractions = false, shouldShowBloom: shouldShowBloom = true, onInteractionStateChange: onInteractionStateChange })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { edition: edition, cloudId: cloudId, userId: userId } = (0, $bQm3c.useSessionData)();
    const { Popup: Popup } = (0, $lsxnT.useChoreographerAssets)();
    const emojiProviderPromise = (0, $cozmU.useMemo)(()=>(0, $32x2E.getEmojiProvider)((0, $kwzZh.default), {
            cloudId: cloudId || '',
            userId: userId || undefined,
            disableUpload: true
        }), [
        cloudId,
        userId
    ]);
    const reactionsMap = (0, $cozmU.useMemo)(()=>$95d3cc090e2e45a6$var$createReactionsMap(reactionsData?.reactions), [
        reactionsData?.reactions
    ]);
    const topReactions = (0, $cozmU.useMemo)(()=>$95d3cc090e2e45a6$var$getTopReactions(reactionsData?.reactions, 3), [
        reactionsData?.reactions
    ]);
    const { handleDefaultReactionClick: handleDefaultReactionClick, handleSummaryReactionClick: handleSummaryReactionClick } = (0, $57464ea87c3c7fcd$export$c666d2c09581fced)({
        contentId: contentId,
        spaceId: spaceId,
        contentType: contentType,
        contentSubType: contentSubType,
        cloudId: cloudId,
        edition: edition ?? undefined,
        reactionsMap: reactionsMap
    });
    const [isSummaryPopupOpen, setIsSummaryPopupOpen] = (0, $cozmU.useState)(false);
    const isEmojiPickerOpen = (0, $c49579fe5d161c4c$export$677c63a231082721)();
    const { animatingEmojis: animatingEmojis, triggerBloomAnimation: triggerBloomAnimation } = (0, $9db24e0dc1ddcbfa$export$673194083bf9485c)();
    const summaryTriggerRef = (0, $cozmU.useRef)(null);
    const previousReactedStateRef = (0, $cozmU.useRef)(new Set());
    const previousPickerOpenRef = (0, $cozmU.useRef)(false);
    const pickerWasOpenRecentlyRef = (0, $cozmU.useRef)(false);
    const isInitialLoadRef = (0, $cozmU.useRef)(true);
    (0, $cozmU.useEffect)(()=>{
        if (isEmojiPickerOpen) pickerWasOpenRecentlyRef.current = true;
        else if (previousPickerOpenRef.current && !isEmojiPickerOpen) {
            pickerWasOpenRecentlyRef.current = true;
            const timeoutId = setTimeout(()=>{
                pickerWasOpenRecentlyRef.current = false;
            }, 1000);
            return ()=>{
                clearTimeout(timeoutId);
            };
        }
        previousPickerOpenRef.current = isEmojiPickerOpen;
    }, [
        isEmojiPickerOpen
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (!reactionsData?.reactions) return;
        const currentReactedEmojis = new Set();
        reactionsData.reactions.forEach((r)=>{
            if (r.reacted) currentReactedEmojis.add(r.emojiId);
        });
        if (isInitialLoadRef.current) {
            isInitialLoadRef.current = false;
            previousReactedStateRef.current = currentReactedEmojis;
            return;
        }
        const previousReactedEmojis = previousReactedStateRef.current;
        const pickerWasOpen = isEmojiPickerOpen || pickerWasOpenRecentlyRef.current;
        const newReactions = [];
        for (const r of reactionsData.reactions)if (r.reacted && !$95d3cc090e2e45a6$var$DEFAULT_EMOJI_IDS.has(r.emojiId) && !previousReactedEmojis.has(r.emojiId)) newReactions.push(r);
        if (shouldShowBloom && pickerWasOpen && newReactions.length > 0 && summaryTriggerRef.current) {
            const rect = summaryTriggerRef.current.getBoundingClientRect();
            const x = rect.left + rect.width / 2;
            const y = rect.top;
            newReactions.forEach((reaction)=>{
                triggerBloomAnimation(x, y, reaction.emojiId);
            });
        }
        previousReactedStateRef.current = currentReactedEmojis;
    }, [
        reactionsData,
        isEmojiPickerOpen,
        triggerBloomAnimation,
        shouldShowBloom
    ]);
    const totalCount = reactionsData?.totalCount || 0;
    const shouldShowSummary = totalCount >= 1;
    const closeEmojiPicker = (0, $cozmU.useCallback)((pickerIsOpen)=>{
        if (typeof document === 'undefined' || !pickerIsOpen) return; // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
        document.dispatchEvent(new KeyboardEvent('keydown', {
            key: 'Escape',
            code: 'Escape',
            bubbles: true,
            cancelable: true
        })); // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
        if (document.activeElement instanceof HTMLElement) // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
        document.activeElement.blur();
         // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
        const triggerButton = document.querySelector('[data-testid="reactionPicker-testid"] button');
        if (triggerButton) triggerButton.click();
    }, []);
    (0, $cozmU.useEffect)(()=>{
        if (shouldCloseInteractions) {
            setIsSummaryPopupOpen(false);
            const pickerOpen = isEmojiPickerOpen;
            requestAnimationFrame(()=>{
                closeEmojiPicker(pickerOpen);
            });
        }
    }, [
        shouldCloseInteractions,
        closeEmojiPicker,
        isEmojiPickerOpen
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (!shouldShowSummary) setIsSummaryPopupOpen(false);
    }, [
        shouldShowSummary
    ]); // Notify parent when interaction state changes
    (0, $cozmU.useEffect)(()=>{
        onInteractionStateChange?.(isEmojiPickerOpen || isSummaryPopupOpen);
    }, [
        isEmojiPickerOpen,
        isSummaryPopupOpen,
        onInteractionStateChange
    ]);
    const visibleReactions = (0, $cozmU.useMemo)(()=>(0, $387c7e4b79a2c2e2$export$f15a7d7a553aca16).slice(0, emojiCount), [
        emojiCount
    ]);
    const allReactionsForModal = (0, $cozmU.useMemo)(()=>$95d3cc090e2e45a6$var$convertToReactionSummaries(reactionsData?.reactions, spaceId, contentId), [
        reactionsData?.reactions,
        spaceId,
        contentId
    ]);
    const emojiClickHandlers = (0, $cozmU.useMemo)(()=>{
        const handlers = {};
        for (const emoji of (0, $387c7e4b79a2c2e2$export$f15a7d7a553aca16)){
            const emojiId = emoji.id || '';
            handlers[emojiId] = ()=>handleDefaultReactionClick(emojiId);
        }
        return handlers;
    }, [
        handleDefaultReactionClick
    ]);
    const handlePopupClose = (0, $cozmU.useCallback)(()=>setIsSummaryPopupOpen(false), []);
    const handleSummaryTriggerClick = (0, $cozmU.useCallback)(()=>{
        if (!isLoading && totalCount > 0) {
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    action: 'clicked',
                    actionSubject: 'button',
                    actionSubjectId: 'omniBarReactionSummary',
                    source: $95d3cc090e2e45a6$var$OMNIBAR_ANALYTICS_SOURCE
                }
            }).fire();
            setIsSummaryPopupOpen((prev)=>!prev);
        }
    }, [
        isLoading,
        totalCount,
        createAnalyticsEvent
    ]);
    const renderPopupContent = (0, $cozmU.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $559fbabe644a799b$export$49a38d37ed252373), {
            reactions: allReactionsForModal,
            emojiProvider: emojiProviderPromise,
            onReactionClick: handleSummaryReactionClick
        }), [
        allReactionsForModal,
        emojiProviderPromise,
        handleSummaryReactionClick
    ]);
    const customAnalyticsAttributes = (0, $cozmU.useMemo)(()=>({
            edition: edition,
            reactionsPlacement: 'omni-bar'
        }), [
        edition
    ]);
    const addReactionLabel = formatMessage($95d3cc090e2e45a6$var$i18n.addReaction);
    const reactionPickerTriggerIcon = (0, $cozmU.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($b35Wv))), {
            label: addReactionLabel,
            color: "var(--ds-icon-subtle, #505258)"
        }), [
        addReactionLabel
    ]);
    const renderTrigger = (0, $cozmU.useCallback)((triggerProps)=>{
        const { ref: popupRef, ...restProps } = triggerProps;
        const handleRef = (node)=>{
            summaryTriggerRef.current = node;
            if (popupRef) {
                if (typeof popupRef === 'function') popupRef(node);
            }
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $559fbabe644a799b$export$46b9d6923ba2ba99), {
            ...restProps,
            ref: handleRef,
            isOpen: isSummaryPopupOpen,
            isLoading: isLoading,
            totalCount: totalCount,
            topReactions: topReactions,
            emojiProvider: emojiProviderPromise,
            onClick: handleSummaryTriggerClick,
            cloudId: cloudId ?? undefined
        });
    }, [
        isSummaryPopupOpen,
        isLoading,
        totalCount,
        topReactions,
        emojiProviderPromise,
        handleSummaryTriggerClick,
        cloudId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        xcss: $95d3cc090e2e45a6$var$styles.reactionsContainer
    }, visibleReactions.map((emoji)=>{
        const emojiId = emoji.id || '';
        const existingReaction = reactionsMap.get(emojiId);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $12725042cedb1af2$export$98b42579a0c01f69), {
            key: emojiId,
            emojiId: emoji,
            emojiProvider: emojiProviderPromise,
            reacted: existingReaction?.reacted || false,
            onClick: emojiClickHandlers[emojiId],
            tooltipDescriptor: emoji.tooltipDescriptor,
            cloudId: cloudId ?? undefined
        });
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $95d3cc090e2e45a6$var$styles.emojiPickerWrapper,
        "data-emoji-picker-open": isEmojiPickerOpen || undefined
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1NF8X.ReactionsLoader), {
        contentId: contentId,
        location: contentType,
        containerId: spaceId,
        containerType: (0, $3FlVr.ReactionContainerType).SPACE,
        contentSubType: contentSubType,
        customAnalyticsAttributes: customAnalyticsAttributes,
        onlyRenderPicker: true,
        pickerQuickReactionEmojiIds: $95d3cc090e2e45a6$var$EMPTY_QUICK_REACTION_IDS,
        useDefaultStyledContainer: true,
        isSubtle: true,
        hidePlaceholder: true,
        showAddReactionText: false,
        reactionPickerTriggerIcon: reactionPickerTriggerIcon
    })), shouldShowSummary && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $95d3cc090e2e45a6$var$styles.separator,
        style: $95d3cc090e2e45a6$var$SEPARATOR_BORDER_STYLE,
        testId: "omni-bar-reaction-separator"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Popup, {
        placement: "top-start",
        content: renderPopupContent,
        isOpen: isSummaryPopupOpen,
        onClose: handlePopupClose,
        trigger: renderTrigger,
        offset: [
            0,
            8
        ]
    })), typeof document !== 'undefined' && animatingEmojis.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cK21K.default), {
        zIndex: (0, $jp2Q3.layers).spotlight()
    }, animatingEmojis.map((animatingEmoji)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $806badad5c4e8903$export$8f2cbc3d71d39c12), {
            key: animatingEmoji.id,
            animatingEmoji: animatingEmoji,
            emojiProvider: emojiProviderPromise,
            emojiSize: (0, $387c7e4b79a2c2e2$export$56912a632457f516)
        }))));
};
const $95d3cc090e2e45a6$export$3366148778529365 = /*#__PURE__*/ (0, $cozmU.memo)($95d3cc090e2e45a6$var$OmniBarReactionsInner);
$95d3cc090e2e45a6$export$3366148778529365.displayName = 'OmniBarReactions';





const $be5272beb8fc0b67$var$defaultEligibility = {
    showReactions: false,
    showComments: false
};
const $be5272beb8fc0b67$export$8cbbebd8b79b4697 = /*#__PURE__*/ (0, $cozmU.createContext)($be5272beb8fc0b67$var$defaultEligibility);
const $be5272beb8fc0b67$export$e7639907c46a9b3c = $be5272beb8fc0b67$export$8cbbebd8b79b4697.Provider;
const $be5272beb8fc0b67$export$3ec4f93cedb84cf3 = ()=>(0, $cozmU.useContext)($be5272beb8fc0b67$export$8cbbebd8b79b4697);






var $jMyy4 = parcelRequire("jMyy4");







const $ca2a3913d7f214d1$var$EMPTY_REACTIONS_DATA = {
    reactions: [],
    totalCount: 0,
    ari: '',
    containerAri: ''
};
/**
 * Transforms raw GraphQL reactions data to the expected format.
 */ const $ca2a3913d7f214d1$var$transformReactionsData = (rawReactionsData)=>{
    const summary = (0, $8wyJO.getReactionsSummary)(rawReactionsData);
    if (!summary) return $ca2a3913d7f214d1$var$EMPTY_REACTIONS_DATA;
    const reactionNodes = summary.reactionsSummaryForEmoji || [];
    const reactions = [];
    for (const node of reactionNodes)if (node && node !== null) reactions.push({
        ari: summary.ari || '',
        containerAri: summary.containerAri || '',
        emojiId: node.emojiId ?? '',
        count: node.count ?? 0,
        reacted: node.reacted || false,
        users: []
    });
    return {
        reactions: reactions,
        totalCount: summary.reactionsCount || 0,
        ari: summary.ari || '',
        containerAri: summary.containerAri || ''
    };
};
const $ca2a3913d7f214d1$export$1d9818af02dc36d3 = ({ contentId: contentId, spaceId: spaceId, contentType: contentType, skip: skip })=>{
    const queryInfo = (0, $cozmU.useMemo)(()=>{
        if (skip) return null;
        try {
            const { isComment: isComment } = (0, $5qhgL.getBooleanLocationTypes)(contentType);
            return (0, $8wyJO.getReactionsQueryInfo)(isComment, contentId, spaceId);
        } catch  {
            return null;
        }
    }, [
        skip,
        contentType,
        contentId,
        spaceId
    ]);
    const { data: rawReactionsData, loading: loading, error: reactionsError } = (0, $jMyy4.useQueryInterop)(queryInfo?.query ?? {}, {
        variables: queryInfo?.queryVariables,
        fetchPolicy: 'cache-only',
        errorPolicy: 'all',
        skip: skip || !queryInfo?.queryVariables,
        __callerPackage__: "experiment-omnibar"
    });
    const reactionsData = (0, $cozmU.useMemo)(()=>{
        if (reactionsError || !rawReactionsData) return $ca2a3913d7f214d1$var$EMPTY_REACTIONS_DATA;
        return $ca2a3913d7f214d1$var$transformReactionsData(rawReactionsData);
    }, [
        rawReactionsData,
        reactionsError
    ]);
    return {
        reactionsData: reactionsData,
        isLoading: loading
    };
};














const $a99c3d99e220f083$var$OMNIBAR_ANALYTICS_SOURCE = 'confluenceOmniBar';
const $a99c3d99e220f083$export$9d7d170793476655 = (onCommentClick)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { expandCommentContainer: expandCommentContainer, setFooterEditorEntry: setFooterEditorEntry } = (0, $fNzRA.useObjectCommentDispatchContext)();
    const { expanded: expanded, isObjectCommentWrapperVisible: isObjectCommentWrapperVisible, footerEditorEntry: footerEditorEntry } = (0, $fNzRA.useObjectCommentContext)();
    const { addFooterCommentAdf: addFooterCommentAdf } = (0, $3mVfX.useCommentsPanelState)();
    const handleCommentClick = (0, $cozmU.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'omniBarCommentSection',
                source: $a99c3d99e220f083$var$OMNIBAR_ANALYTICS_SOURCE
            }
        }).fire();
        const isShowStickyDraft = !isObjectCommentWrapperVisible && (addFooterCommentAdf || expanded) && footerEditorEntry !== (0, $fNzRA.AddFooterCommentMode).STICKY_DRAFT;
        if (!expanded) expandCommentContainer({
            entryPoint: 'pageFooter'
        });
        if (isShowStickyDraft || !isObjectCommentWrapperVisible) setFooterEditorEntry((0, $fNzRA.AddFooterCommentMode).STICKY_DRAFT);
        else if (typeof document !== 'undefined') document.querySelector(`[data-testid='object-comment-wrapper']`)?.scrollIntoView({
            behavior: 'smooth'
        });
        onCommentClick?.();
    }, [
        createAnalyticsEvent,
        expandCommentContainer,
        setFooterEditorEntry,
        expanded,
        isObjectCommentWrapperVisible,
        footerEditorEntry,
        addFooterCommentAdf,
        onCommentClick
    ]);
    return {
        handleCommentClick: handleCommentClick
    };
};


const $3117c19d34064be1$var$logger = (0, $7W8i8.getLogger)('experiment-omnibar');
const $3117c19d34064be1$var$OMNIBAR_ANALYTICS_SOURCE = 'confluenceOmniBar'; /** Suppress the initial mount transition, but allow it on later remounts so the OmniBar can slide back in from the bottom of the page. */ 
let $3117c19d34064be1$var$hasEverMounted = false;
function $3117c19d34064be1$var$wasOmnibarSSRd() {
    if (typeof document === 'undefined') return false;
     // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    const omnibarElement = document.querySelector('[data-testid="omni-bar"]');
    if (!omnibarElement) return false;
    const computedElementStyle = window.getComputedStyle(omnibarElement);
    return computedElementStyle.position === 'sticky' && computedElementStyle.visibility !== 'hidden';
}
function $3117c19d34064be1$var$getPinStateFromStorage() {
    try {
        const stored = (0, $17wUi.confluenceLocalStorageInstance)?.getItem((0, $1UApO.PERSISTED_KEYS_ON_SERVER).PERSISTED_OMNIBAR_PINNED);
        if (stored === 'true') return true;
        if (stored === 'false') return false;
    } catch (e) {
        $3117c19d34064be1$var$logger.error`Omnibar failed to read pin state from storage: ${e}`;
    }
    return true;
}
function $3117c19d34064be1$var$persistPinState(pinned) {
    try {
        (0, $17wUi.confluenceLocalStorageInstance)?.setItem((0, $1UApO.PERSISTED_KEYS_ON_SERVER).PERSISTED_OMNIBAR_PINNED, pinned ? 'true' : 'false');
    } catch (e) {
        $3117c19d34064be1$var$logger.error`Omnibar failed to persist pin state to storage: ${e}`;
    }
}
const $3117c19d34064be1$var$i18n = (0, $kSwu1.defineMessages)({
    hideOmniBar: {
        id: "experiment-omnibar.omni-bar.hide-button",
        defaultMessage: "Hide toolbar"
    },
    pinOmniBar: {
        id: "experiment-omnibar.omni-bar.pin-button",
        defaultMessage: "Pin toolbar"
    },
    comment: {
        id: "experiment-omnibar.comments.comment-button",
        defaultMessage: "Comment"
    }
});
const $3117c19d34064be1$var$styles = {
    responsiveContainer: "_4bt5LAYvD1 _2WAcuGYvD1 _1mT5xdHE3j _39xV02N91d _3iDTPbQ4SZ _0hPCNLz9WS _37wbyuDIqT _0jFU0VL04q _0Bm75GPgdg _1wydGWNHnM _42Yu6B7dHp",
    responsiveContainerUnpinned: "_2YLqiKIZbP _1EqgXlOAqP",
    responsiveContainerInner: "_39xV02N91d _3iDTPbQ4SZ _37wbyuDIqT _0hPCNLz9WS",
    barContainerBase: "_39xV02E6Kk _1pp6NdIZbP _1YKVNs7dHp _1VJPcaBj0j",
    barHidden: "_1VJPcaykWR _1YKVNsdnbC _1pp6NdYbGa",
    barSlideIn: "_1VJPcaBj0j _1YKVNs7dHp _1pp6NdIZbP",
    barNoTransition: "_23rrnHYbGa",
    barTransition: "_23rrnHVYho",
    buttonStyle: "_0bjKvDyzSk _0KLXruqi9L _2OUyjtzwhj",
    reactionsContainerBase: "_4FKVYE2ADO _4bt5LAYvD1 _2WAcuGYvD1",
    commentsContainerBase: "_4FKVYE2ADO",
    noPointerEvents: "_1pp6NdYbGa",
    containerHiddenWhenDimensionsNotReady: "_0fKRyPnQyn",
    pinContainerBase: "_0bjKvDS5Zs _23rrnHuubs _0KLXruqi9L",
    horizontalCenteringFixForToggleButton: "_2Zuz6QS40j",
    pinButtonHiddenWhenNotHovered: "_1YKVNsdnbC _1pp6NdYbGa"
};
const $3117c19d34064be1$export$d4fe9bcf0aa84dd5 = ({ contentId: contentId, spaceId: spaceId, contentType: contentType, contentSubType: contentSubType, onCommentClick: onCommentClick })=>{
    const isSSR = typeof window === 'undefined';
    const initialPinState = $3117c19d34064be1$var$getPinStateFromStorage(); /**
                                                     * Detect if an SSR'd omnibar is already visible — call only once and cache in ref.
                                                     * This must not be called on every render because subsequent renders commit client
                                                     * styles to the DOM, making the check return stale results.
                                                     */ 
    const wasOmnibarSSRdRef = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useRef(null);
    if (wasOmnibarSSRdRef.current === null) wasOmnibarSSRdRef.current = isSSR || $3117c19d34064be1$var$wasOmnibarSSRd();
    const isHydratingAfterSSR = wasOmnibarSSRdRef.current;
    const [hasHydrated, setHasHydrated] = (0, $cozmU.useState)(!isHydratingAfterSSR);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const [isPinned, setIsPinned] = (0, $cozmU.useState)(initialPinState);
    const [isHovered, setIsHovered] = (0, $cozmU.useState)(false);
    const [shouldHideInstantly, setHideInstantly] = (0, $cozmU.useState)(false);
    const [isAnimatingOut, setIsAnimatingOut] = (0, $cozmU.useState)(false);
    const [hasActiveInteraction, setHasActiveInteraction] = (0, $cozmU.useState)(false);
    const [hasCompletedInitialSlideUp, setHasCompletedInitialSlideUp] = (0, $cozmU.useState)(isHydratingAfterSSR);
    const [isAnimatingOutForUnmount, setIsAnimatingOutForUnmount] = (0, $cozmU.useState)(false);
    const hasHoveredRef = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useRef($3117c19d34064be1$var$hasEverMounted);
    const containerRef = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useRef(null);
    const isMountedRef = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useRef(true);
    const barWasVisibleRef = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useRef(false); // Track if we rendered on server to know whether to skip animation
    const wasServerRenderedRef = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useRef(isHydratingAfterSSR);
    (0, $cozmU.useEffect)(()=>{
        if (isHydratingAfterSSR) setHasHydrated(true);
    }, [
        isHydratingAfterSSR
    ]);
    const handleOmniBarMouseEnter = (0, $cozmU.useCallback)(()=>{
        if (isAnimatingOut) return;
        hasHoveredRef.current = true;
        setHideInstantly(false);
        setIsHovered(true);
    }, [
        isAnimatingOut
    ]);
    const handleOmniBarMouseLeave = (0, $cozmU.useCallback)(()=>{
        setIsHovered(false);
    }, []);
    (0, $cozmU.useEffect)(()=>{
        const container = containerRef.current;
        if (!container || isPinned) return;
        const handleNativeMouseLeave = (e)=>{
            const relatedTarget = e.relatedTarget;
            if (relatedTarget) {
                if (container.contains(relatedTarget)) return;
            } // Don't hide if a popup interaction is active (emoji picker, summary popup)
            if (hasActiveInteraction) return;
            setIsAnimatingOut(true);
            setIsHovered(false);
            setTimeout(()=>{
                setIsAnimatingOut(false);
            }, 300);
        };
        container.addEventListener('mouseleave', handleNativeMouseLeave);
        return ()=>{
            container.removeEventListener('mouseleave', handleNativeMouseLeave);
        };
    }, [
        isPinned,
        hasActiveInteraction
    ]);
    const shouldHideExternally = (0, $b0EGa.useShouldHideOmniBar)();
    const hasReceivedHideRequest = (0, $b0EGa.useHasReceivedOmniBarHideRequest)();
    const { mode: rovoMode } = (0, $93Gae.useRovoExperienceAPIStore)();
    const isAIMiniModalOpen = rovoMode === 'mini-modal';
    const { handleCommentClick: handleCommentClick } = (0, $a99c3d99e220f083$export$9d7d170793476655)(onCommentClick);
    const { showReactions: showReactions, showComments: showComments } = (0, $be5272beb8fc0b67$export$3ec4f93cedb84cf3)();
    const showCommentButton = showComments && showReactions;
    const { reactionsData: reactionsData, isLoading: reactionsLoading } = (0, $ca2a3913d7f214d1$export$1d9818af02dc36d3)({
        contentId: contentId,
        spaceId: spaceId,
        contentType: contentType,
        skip: !showReactions
    });
    const pageContentDimensions = (0, $aOKRX.usePageContentDimensions)();
    const minContentAreaWidth = 620;
    const shouldHideForSmallViewport = !isSSR && typeof pageContentDimensions.width === 'number' && pageContentDimensions.width > 0 && pageContentDimensions.width <= minContentAreaWidth;
    const isBarVisible = !shouldHideForSmallViewport && showReactions;
    const hasFiredRenderedRef = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useRef(false);
    (0, $cozmU.useEffect)(()=>{
        if (!isBarVisible || hasFiredRenderedRef.current) return;
        hasFiredRenderedRef.current = true;
        createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                action: 'rendered',
                actionSubject: 'omniBar',
                actionSubjectId: 'omniBarRendered',
                source: $3117c19d34064be1$var$OMNIBAR_ANALYTICS_SOURCE
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        isBarVisible
    ]);
    const isContainerVisible = typeof pageContentDimensions.width !== 'number' || pageContentDimensions.width > 0;
    (0, $cozmU.useEffect)(()=>{
        if (!isContainerVisible) return; // If this was rendered on the server, skip animation on SPA hydration
        if (wasServerRenderedRef.current) {
            $3117c19d34064be1$var$hasEverMounted = true;
            return;
        }
        isMountedRef.current = true;
        const frameId = requestAnimationFrame(()=>{
            requestAnimationFrame(()=>{
                if (isMountedRef.current) {
                    setHasCompletedInitialSlideUp(true);
                    $3117c19d34064be1$var$hasEverMounted = true;
                }
            });
        });
        return ()=>{
            isMountedRef.current = false;
            cancelAnimationFrame(frameId);
        };
    }, [
        isContainerVisible
    ]);
    const isContainerHiddenForLayoutShift = !isSSR && hasHydrated && typeof pageContentDimensions.width === 'number' && pageContentDimensions.width === 0;
    const handlePinToggle = (0, $cozmU.useCallback)(()=>{
        if (!isPinned) {
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    action: 'pinned',
                    actionSubject: 'button',
                    actionSubjectId: 'omniBarPinned',
                    source: $3117c19d34064be1$var$OMNIBAR_ANALYTICS_SOURCE
                }
            }).fire();
            setHideInstantly(true);
            setIsAnimatingOut(false);
            setIsPinned(true);
            $3117c19d34064be1$var$persistPinState(true); // eslint-disable-next-line @atlassian/perf-linting/no-chain-state-updates -- intentional rAF to clear hideInstantly after paint
            requestAnimationFrame(()=>setHideInstantly(false));
        } else {
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    action: 'unpinned',
                    actionSubject: 'button',
                    actionSubjectId: 'omniBarUnpinned',
                    source: $3117c19d34064be1$var$OMNIBAR_ANALYTICS_SOURCE
                }
            }).fire();
            setIsAnimatingOut(true);
            setIsHovered(false);
            setHasActiveInteraction(false);
            setIsPinned(false);
            $3117c19d34064be1$var$persistPinState(false); // eslint-disable-next-line @atlassian/perf-linting/no-chain-state-updates -- intentional delayed reset after unpin animation
            setTimeout(()=>setIsAnimatingOut(false), 200);
        }
    }, [
        isPinned,
        createAnalyticsEvent
    ]);
    const renderIcon = (0, $cozmU.useCallback)((iconProps)=>isPinned ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))), iconProps) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($j6vyT))), iconProps), [
        isPinned
    ]);
    const barIsVisible = !shouldHideExternally && !isAIMiniModalOpen && (isPinned && hasCompletedInitialSlideUp || isHovered || hasActiveInteraction); // When bar becomes hidden (unpin or external request), keep content mounted for slide-down animation
    /* eslint-disable @atlassian/perf-linting/no-chain-state-updates -- intentional: deferred setState after 250ms for slide-down animation */ (0, $cozmU.useEffect)(()=>{
        if (barIsVisible) {
            barWasVisibleRef.current = true;
            setIsAnimatingOutForUnmount(false);
            return;
        }
        if (barWasVisibleRef.current) {
            barWasVisibleRef.current = false;
            setIsAnimatingOutForUnmount(true);
            const timer = setTimeout(()=>setIsAnimatingOutForUnmount(false), 250);
            return ()=>clearTimeout(timer);
        }
    }, [
        barIsVisible
    ]); /* eslint-enable @atlassian/perf-linting/no-chain-state-updates */ 
    const shouldRenderBarContent = barIsVisible || isAnimatingOutForUnmount;
    if (shouldHideForSmallViewport || !showReactions) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        ref: containerRef,
        testId: "omni-bar",
        xcss: (0, $w6R6I.cx)($3117c19d34064be1$var$styles.responsiveContainer, !isPinned && $3117c19d34064be1$var$styles.responsiveContainerUnpinned, shouldHideExternally && $3117c19d34064be1$var$styles.noPointerEvents, isContainerHiddenForLayoutShift && $3117c19d34064be1$var$styles.containerHiddenWhenDimensionsNotReady),
        onMouseEnter: handleOmniBarMouseEnter,
        onFocus: handleOmniBarMouseEnter,
        onMouseLeave: handleOmniBarMouseLeave,
        onBlur: handleOmniBarMouseLeave
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $3117c19d34064be1$var$styles.responsiveContainerInner
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.100",
        alignBlock: "center",
        xcss: (0, $w6R6I.cx)($3117c19d34064be1$var$styles.barContainerBase, $3117c19d34064be1$var$styles.horizontalCenteringFixForToggleButton, $3117c19d34064be1$var$styles.barNoTransition, (!isPinned || shouldHideExternally || isAIMiniModalOpen || isPinned && !hasCompletedInitialSlideUp) && $3117c19d34064be1$var$styles.barHidden, !shouldHideInstantly && !shouldHideExternally && !isAIMiniModalOpen && (isPinned && hasCompletedInitialSlideUp || isHovered || hasActiveInteraction) && $3117c19d34064be1$var$styles.barSlideIn, (hasHoveredRef.current || hasReceivedHideRequest) && $3117c19d34064be1$var$styles.barTransition)
    }, shouldRenderBarContent && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, showReactions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($3117c19d34064be1$var$styles.reactionsContainerBase, $3117c19d34064be1$var$styles.buttonStyle)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $95d3cc090e2e45a6$export$3366148778529365), {
        contentId: contentId,
        spaceId: spaceId,
        contentType: contentType,
        contentSubType: contentSubType,
        reactionsData: reactionsData,
        isLoading: reactionsLoading,
        shouldCloseInteractions: isAnimatingOutForUnmount || shouldHideExternally || isAIMiniModalOpen || !isPinned && !isHovered && !hasActiveInteraction,
        shouldShowBloom: !isAnimatingOutForUnmount && !shouldHideExternally && !isAIMiniModalOpen && (isPinned && hasCompletedInitialSlideUp || isHovered || hasActiveInteraction),
        onInteractionStateChange: setHasActiveInteraction
    })), showCommentButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($3117c19d34064be1$var$styles.commentsContainerBase, $3117c19d34064be1$var$styles.buttonStyle)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
        position: "top",
        content: formatMessage($3117c19d34064be1$var$i18n.comment),
        hideTooltipOnClick: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        appearance: "subtle",
        onClick: handleCommentClick,
        iconBefore: (0, (/*@__PURE__*/$parcel$interopDefault($cY2bA)))
    }, formatMessage($3117c19d34064be1$var$i18n.comment)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($3117c19d34064be1$var$styles.pinContainerBase, isPinned && !isHovered && $3117c19d34064be1$var$styles.pinButtonHiddenWhenNotHovered)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
        position: "top",
        content: isPinned ? formatMessage($3117c19d34064be1$var$i18n.hideOmniBar) : formatMessage($3117c19d34064be1$var$i18n.pinOmniBar),
        hideTooltipOnClick: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        appearance: "subtle",
        shape: "circle",
        icon: renderIcon,
        label: isPinned ? formatMessage($3117c19d34064be1$var$i18n.hideOmniBar) : formatMessage($3117c19d34064be1$var$i18n.pinOmniBar),
        onClick: handlePinToggle
    }))))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1eaCJ.ExperienceSuccess), {
        name: (0, $irVI7.VIEW_OMNIBAR_EXPERIENCE)
    }));
};


/**
 * Inner component that provides context data to OmniBar.
 */ const $695c4789ab8d8ace$var$OmniBarWrapperInner = ()=>{
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const [contentType] = (0, $ep3mz.useContentType)();
    const spaceId = (0, $7QM6o.useSpaceId)();
    const { subType: subType } = (0, $9sGCn.getCachedPageData)(contentId);
    if (!contentId || !spaceId || !contentType) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3117c19d34064be1$export$d4fe9bcf0aa84dd5), {
        contentId: contentId,
        spaceId: spaceId,
        contentType: contentType,
        contentSubType: subType
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ln0hx.ExperienceStart), {
        name: (0, $irVI7.VIEW_OMNIBAR_EXPERIENCE),
        attributes: {
            contentId: contentId,
            contentType: contentType
        }
    }));
};
const $695c4789ab8d8ace$export$621326c554b583ec = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hSqtY.TransparentErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).FLYWHEEL_ENGAGEMENT
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($695c4789ab8d8ace$var$OmniBarWrapperInner, null));



var $8amSw = parcelRequire("8amSw");


var $6UMDm = parcelRequire("6UMDm");


var $ayQVU = parcelRequire("ayQVU");





var $1kHsc = parcelRequire("1kHsc");





var $6mKj3 = parcelRequire("6mKj3");


var $9wGTI = parcelRequire("9wGTI");


/* eslint-disable confluence-feature-gating/inline-expVal-params */ 



var $ivb8S = parcelRequire("ivb8S");


var $dBcar = parcelRequire("dBcar");

const $586b596f3637df5c$var$COHORT_PARAM = 'cohort';
const $586b596f3637df5c$export$a4a828fdcd26ce47 = (skip = false)=>{
    const { data: onboardingStateData, loading: onboardingStateLoading, error: onboardingStateError } = (0, $ivb8S.useGetOnboardingState)([
        (0, $dBcar.ONBOARDING_EXPERIENCES).IS_FOUNDING_ADMIN
    ], skip);
    const { isFoundingAdmin: isFoundingAdmin } = (0, $ivb8S.deserializeState)(onboardingStateData);
    if (skip) return {
        showReactions: false,
        showComments: false
    };
    if (isFoundingAdmin || onboardingStateLoading || onboardingStateError) return {
        showReactions: false,
        showComments: false
    };
    const showReactions = (0, $6mKj3.expValEquals)('cc_engagement_omnibar', $586b596f3637df5c$var$COHORT_PARAM, 'variant_reactions') || (0, $6mKj3.expValEquals)('cc_engagement_omnibar', $586b596f3637df5c$var$COHORT_PARAM, 'variant_reactions_comments') || (0, $6mKj3.expValEquals)('cc_engagement_omnibar_smb', $586b596f3637df5c$var$COHORT_PARAM, 'variant_reactions') || (0, $6mKj3.expValEquals)('cc_engagement_omnibar_smb', $586b596f3637df5c$var$COHORT_PARAM, 'variant_reactions_comments');
    const showComments = (0, $6mKj3.expValEquals)('cc_engagement_omnibar', $586b596f3637df5c$var$COHORT_PARAM, 'variant_reactions_comments') || (0, $6mKj3.expValEquals)('cc_engagement_omnibar_smb', $586b596f3637df5c$var$COHORT_PARAM, 'variant_reactions_comments');
    return {
        showReactions: showReactions,
        showComments: showComments
    };
};



var $l5y3Y = parcelRequire("l5y3Y");


var $aK6zf = parcelRequire("aK6zf");
/* ImportFeedbackBanner.tsx generated by @compiled/babel-plugin v2.0.0 */ 


















var $4aRua = parcelRequire("4aRua");





var $l3wuH = parcelRequire("l3wuH");


var $c8bBH = parcelRequire("c8bBH");


var $93fnf = parcelRequire("93fnf");





var $7akNQ = parcelRequire("7akNQ");








var $jQob7 = parcelRequire("jQob7");


var $4mihy = parcelRequire("4mihy");

const $99af38a0b1766526$var$LOCAL_STORAGE_CONTENTID_LIMIT = 200; // 30 bytes per contentId, 200 is 6KB
const $99af38a0b1766526$var$IMPORT_SOURCE_NOTION = 'Notion';
const $99af38a0b1766526$var$translations = (0, $kSwu1.defineMessages)({
    bannerText: {
        id: "import-feedback.banner-text",
        defaultMessage: "This content is imported. How does it look?"
    }
});
const $99af38a0b1766526$var$styles = {
    root: "_0Of8r25zaO _1Znuxb5zaO _1wydGW5zaO _2Zuz6Q5zaO"
};
const $99af38a0b1766526$var$unboundedStyles = {
    root: "_39xV02rFfx _2XsHFM5ksT _1mT5xdRAKS"
};
const $99af38a0b1766526$export$f2bf6e79bf9b9470 = ({ importSource: importSource, importDate: importDate, contentId: contentId })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const [isModalOpen, setIsModalOpen] = (0, $cozmU.useState)(false); //TODO (@rwang): Refactor this to use the ImportFeedbackStorageManager (CCIMPORTER-509)
    const [bannerDisabledContentIds, setBannerDisabledContentIds] = (0, $cozmU.useState)(()=>JSON.parse((0, $17wUi.confluenceLocalStorageInstance).getItem((0, $1UApO.PERSISTED_KEYS_ON_SERVER).PERSISTED_IMPORT_FEEDBACK_DISABLED)) || []);
    (0, $cozmU.useEffect)(()=>{
        createAnalyticsEvent({
            type: 'sendScreenEvent',
            data: {
                name: 'importFeedbackBanner'
            }
        }).fire();
    }, [
        createAnalyticsEvent
    ]);
    const handleFeedbackClick = ()=>{
        setIsModalOpen(true);
    }; //TODO (@rwang): Refactor this to use the ImportFeedbackStorageManager (CCIMPORTER-509)
    const handleDismissClick = ()=>{
        if (bannerDisabledContentIds.length >= $99af38a0b1766526$var$LOCAL_STORAGE_CONTENTID_LIMIT) bannerDisabledContentIds.shift();
        const updatedIds = [
            ...bannerDisabledContentIds,
            contentId
        ];
        (0, $17wUi.confluenceLocalStorageInstance).setItem((0, $1UApO.PERSISTED_KEYS_ON_SERVER).PERSISTED_IMPORT_FEEDBACK_DISABLED, JSON.stringify(updatedIds));
        setBannerDisabledContentIds(updatedIds);
    };
    const formattedSource = importSource && $99af38a0b1766526$var$IMPORT_SOURCE_NOTION; // Hardcoded with Notion until backend is updated
    const isFeedbackDisabled = bannerDisabledContentIds.includes(contentId);
    if (isFeedbackDisabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7akNQ.FlagsProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-vc": "import-feedback-banner",
        className: (0, $hekY6.default)([
            $99af38a0b1766526$var$unboundedStyles.root
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($99af38a0b1766526$var$styles.root),
        backgroundColor: "color.background.accent.purple.subtler"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        justifyContent: "space-between",
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), null), " ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        gap: "space.400",
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        weight: "medium"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $99af38a0b1766526$var$translations.bannerText)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        gap: "space.100",
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($c8bBH))),
        label: "Thumbs Up",
        testId: "import-feedback-banner-thumbs-up-button",
        onClick: ()=>{
            (0, $4mihy.submitSurveyFeedback)(createAnalyticsEvent, 'importedPageFeedbackBanner', formattedSource, importDate, contentId, 'positive');
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    action: 'clicked',
                    actionSubject: 'thumsUpButton',
                    actionSubjectId: 'importFeedbackSurvey',
                    source: 'importedPageFeedbackBanner'
                }
            }).fire();
            handleDismissClick();
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($93fnf))),
        label: "Thumbs Down",
        testId: "import-feedback-banner-thumbs-down-button",
        onClick: ()=>{
            handleFeedbackClick();
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    action: 'clicked',
                    actionSubject: 'thumsDownButton',
                    actionSubjectId: 'importFeedbackSurvey',
                    source: 'importedPageFeedbackBanner'
                }
            }).fire();
        }
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        appearance: "subtle",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($l3wuH))),
        label: "Close",
        testId: "import-feedback-banner-close-button",
        onClick: ()=>{
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    action: 'clicked',
                    actionSubject: 'dismissButton',
                    actionSubjectId: 'importFeedbackSurvey',
                    source: 'importedPageFeedbackBanner'
                }
            }).fire();
            handleDismissClick();
        }
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jQob7.FeedbackModal), {
        isOpen: isModalOpen,
        closeModal: ()=>setIsModalOpen(false),
        importSource: formattedSource,
        importDate: importDate,
        contentId: contentId,
        onFeedbackSubmit: handleDismissClick
    })));
};



var $4yKPM = parcelRequire("4yKPM");


var $hq2Sz = parcelRequire("hq2Sz");


var $kZEms = parcelRequire("kZEms");


var $8tF9d = parcelRequire("8tF9d");



var $cmBjr = parcelRequire("cmBjr");


var $lfmjq = parcelRequire("lfmjq");


var $83sfO = parcelRequire("83sfO");


var $3jwuS = parcelRequire("3jwuS");


var $efvKr = parcelRequire("efvKr");


var $398ES = parcelRequire("398ES");


var $hdxAi = parcelRequire("hdxAi");


var $cMKmt = parcelRequire("cMKmt");


var $1NBp8 = parcelRequire("1NBp8");


var $2VZOl = parcelRequire("2VZOl");


var $2xS8W = parcelRequire("2xS8W");


var $70pcM = parcelRequire("70pcM");


var $lrMxq = parcelRequire("lrMxq");


var $fzhfU = parcelRequire("fzhfU");


var $3oWMY = parcelRequire("3oWMY");


var $3WPGR = parcelRequire("3WPGR");


var $fIKxq = parcelRequire("fIKxq");


var $jXhAV = parcelRequire("jXhAV");


var $fSC8h = parcelRequire("fSC8h");


var $8WQTF = parcelRequire("8WQTF");


var $kJNMt = parcelRequire("kJNMt");





var $e4o8D = parcelRequire("e4o8D");


var $60cDW = parcelRequire("60cDW");


var $78QFu = parcelRequire("78QFu");


var $eSLr0 = parcelRequire("eSLr0");


var $juCeZ = parcelRequire("juCeZ");


var $3nzqU = parcelRequire("3nzqU");





const $cfdf4590bc9d9b83$export$f9de7c50725ea941 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "odo_M",
    name: "TeammateContentRecommendationBanner",
    loader: async ()=>(await (parcelRequire("keBh8"))).TeammateContentRecommendationBanner
});







const $61182ec78da4ef5a$export$fa7cecb87e076447 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "VY99V",
    name: "CwrWelcomeBanner",
    loader: async ()=>(await (parcelRequire("95jar"))).CwrWelcomeBanner
});



var $dGhsu = parcelRequire("dGhsu");







const $92fa5c1401245a45$export$3776ef07d76bd666 = (t0)=>{
    const $ = (0, $bDgLe.c)(6);
    const { contentBodyDynamic: contentBodyDynamic, contentId: contentId, contentIdFromQuery: contentIdFromQuery, onCurrentContentBodyDynamicChange: onCurrentContentBodyDynamicChange } = t0;
    let t1;
    let t2;
    if ($[0] !== contentBodyDynamic || $[1] !== contentId || $[2] !== contentIdFromQuery || $[3] !== onCurrentContentBodyDynamicChange) {
        t1 = ()=>{
            const isCurrentContent = contentId === contentIdFromQuery;
            onCurrentContentBodyDynamicChange?.(isCurrentContent ? contentBodyDynamic : undefined, isCurrentContent ? contentIdFromQuery : undefined);
        };
        t2 = [
            contentBodyDynamic,
            contentId,
            contentIdFromQuery,
            onCurrentContentBodyDynamicChange
        ];
        $[0] = contentBodyDynamic;
        $[1] = contentId;
        $[2] = contentIdFromQuery;
        $[3] = onCurrentContentBodyDynamicChange;
        $[4] = t1;
        $[5] = t2;
    } else {
        t1 = $[4];
        t2 = $[5];
    }
    (0, $cozmU.useEffect)(t1, t2);
    return null;
};








const $36bdded0429e1042$export$894ebd5d2e91304b = (t0)=>{
    const $ = (0, $bDgLe.c)(4);
    const { contentId: contentId, onCurrentContentBodyDynamicChange: onCurrentContentBodyDynamicChange } = t0;
    let t1;
    let t2;
    if ($[0] !== contentId || $[1] !== onCurrentContentBodyDynamicChange) {
        t1 = ()=>{
            onCurrentContentBodyDynamicChange?.(undefined, contentId);
        };
        t2 = [
            contentId,
            onCurrentContentBodyDynamicChange
        ];
        $[0] = contentId;
        $[1] = onCurrentContentBodyDynamicChange;
        $[2] = t1;
        $[3] = t2;
    } else {
        t1 = $[2];
        t2 = $[3];
    }
    (0, $cozmU.useEffect)(t1, t2);
    return null;
};






const $889eab36c217c00c$export$bdd4a5944172b352 = (0, $jmjWc.LoadableBackground)({
    __loadable_id__: "kTgHc",
    name: "SatisfactionSurveysLoader",
    loader: async ()=>(await (parcelRequire("72oMs"))).SatisfactionSurveys
});



var $aXika = parcelRequire("aXika");











var $7zgzO = parcelRequire("7zgzO");





var $7Sm4c = parcelRequire("7Sm4c");


var $1uFM6 = parcelRequire("1uFM6");


var $liGyh = parcelRequire("liGyh");


var $39nIX = parcelRequire("39nIX");


var $beAZw = parcelRequire("beAZw");


var $8uhVX = parcelRequire("8uhVX");


var $k5dl6 = parcelRequire("k5dl6");


var $3s9yq = parcelRequire("3s9yq");







const $9450efcd5fbf758a$export$9fdf0be90cc81aa6 = /*#__PURE__*/ (0, $cozmU.memo)((t0)=>{
    const $ = (0, $bDgLe.c)(33);
    const { contentId: contentId, loadingPriority: loadingPriority, isFabricPage: isFabricPage } = t0;
    const { editCommentId: editCommentId, replyToCommentId: replyToCommentId } = (0, $liGyh.useInlineCommentQueryParams)();
    const { getQueryParams: getQueryParams } = (0, $cozmU.useContext)((0, $7zgzO.RoutesContext));
    let t1;
    if ($[0] !== getQueryParams) {
        t1 = getQueryParams();
        $[0] = getQueryParams;
        $[1] = t1;
    } else t1 = $[1];
    const { focusedCommentId: queryParamsFocusedCommentId } = t1;
    const renderServerPlaceholder = (0, $e4o8D.useRenderServerPlaceholder)();
    const focusedCommentId = queryParamsFocusedCommentId ? queryParamsFocusedCommentId : undefined;
    let t2;
    if ($[2] !== contentId) {
        t2 = {
            pageId: contentId
        };
        $[2] = contentId;
        $[3] = t2;
    } else t2 = $[3];
    const t3 = !contentId || isFabricPage;
    let t4;
    if ($[4] !== t2 || $[5] !== t3) {
        t4 = {
            variables: t2,
            skip: t3
        };
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else t4 = $[6];
    const { error: error } = (0, $jMyy4.useQueryInterop)((0, $3s9yq.InlineCommentsQuery), {
        ...t4,
        __callerPackage__: "view-page-common"
    });
    if (error) (0, $7Sm4c.markErrorAsHandled)(error);
    const t5 = focusedCommentId || "";
    const t6 = contentId || "";
    let t7;
    if ($[7] !== t5 || $[8] !== t6) {
        t7 = {
            commentId: t5,
            contentId: t6
        };
        $[7] = t5;
        $[8] = t6;
        $[9] = t7;
    } else t7 = $[9];
    const t8 = !(contentId && focusedCommentId);
    let t9;
    if ($[10] !== t7 || $[11] !== t8) {
        t9 = {
            variables: t7,
            fetchPolicy: "cache-first",
            skip: t8
        };
        $[10] = t7;
        $[11] = t8;
        $[12] = t9;
    } else t9 = $[12];
    const { data: data, error: focusedCommentError } = (0, $jMyy4.useQueryInterop)((0, $k5dl6.default), {
        ...t9,
        __callerPackage__: "view-page-common"
    });
    if (focusedCommentError && (0, $1uFM6.isUnauthorizedError)(focusedCommentError)) (0, $7Sm4c.markErrorAsHandled)(focusedCommentError);
    const isFocusedInlineComment = Boolean(data?.comments?.nodes?.[0]?.isInlineComment);
    const { firstHighlightClicked: firstHighlightClicked, shouldDisplaySidebar: shouldDisplaySidebar } = (0, $9jl6v.useInlineCommentsContext)();
    const { toggleSidebar: toggleSidebar } = (0, $9jl6v.useInlineCommentsDispatchContext)();
    let t10;
    let t11;
    if ($[13] !== editCommentId || $[14] !== firstHighlightClicked || $[15] !== isFocusedInlineComment || $[16] !== replyToCommentId || $[17] !== shouldDisplaySidebar || $[18] !== toggleSidebar) {
        t10 = ()=>{
            if (window.__SSR_RENDERED__ && isFocusedInlineComment || isFocusedInlineComment || replyToCommentId || editCommentId && shouldDisplaySidebar || firstHighlightClicked && shouldDisplaySidebar) toggleSidebar(true);
        };
        t11 = [
            isFocusedInlineComment,
            replyToCommentId,
            editCommentId,
            firstHighlightClicked,
            toggleSidebar,
            shouldDisplaySidebar
        ];
        $[13] = editCommentId;
        $[14] = firstHighlightClicked;
        $[15] = isFocusedInlineComment;
        $[16] = replyToCommentId;
        $[17] = shouldDisplaySidebar;
        $[18] = toggleSidebar;
        $[19] = t10;
        $[20] = t11;
    } else {
        t10 = $[19];
        t11 = $[20];
    }
    (0, $cozmU.useEffect)(t10, t11);
    if (renderServerPlaceholder && isFocusedInlineComment) {
        let t12;
        if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
            t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8uhVX.FocusedInlineComment), null);
            $[21] = t12;
        } else t12 = $[21];
        return t12;
    }
    let t12;
    if ($[22] !== renderServerPlaceholder) {
        t12 = renderServerPlaceholder && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $beAZw.InlineCommentsLoadingSkeleton), null);
        $[22] = renderServerPlaceholder;
        $[23] = t12;
    } else t12 = $[23];
    let t13;
    if ($[24] !== contentId || $[25] !== focusedCommentId || $[26] !== isFabricPage || $[27] !== loadingPriority || $[28] !== shouldDisplaySidebar) {
        t13 = shouldDisplaySidebar && !isFabricPage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $39nIX.InlineCommentsLoader), {
            pageId: contentId,
            isFabricPage: Boolean(isFabricPage),
            loadingPriority: loadingPriority || (0, $398ES.LoadingPriority).PAINT,
            focusedCommentId: focusedCommentId
        });
        $[24] = contentId;
        $[25] = focusedCommentId;
        $[26] = isFabricPage;
        $[27] = loadingPriority;
        $[28] = shouldDisplaySidebar;
        $[29] = t13;
    } else t13 = $[29];
    let t14;
    if ($[30] !== t12 || $[31] !== t13) {
        t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, t12, t13);
        $[30] = t12;
        $[31] = t13;
        $[32] = t14;
    } else t14 = $[32];
    return t14;
});





/**
 * @generated SignedSource<<ece0919a210000cf512aefa69a030c83>>
 * @relayHash e3b5b71fba9dd3f54fb8973290ef6043
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 4aab61ca8a29b1a5dfaedd2cb2eb2392eaeb65d57e63642b5704289a568bf312
const $5f3802d139ffef0e$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "versionOverride"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "version",
                    "variableName": "versionOverride"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "status"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "subType"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useRenderLivePageEarlyContentSubTypeAndStatusQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useRenderLivePageEarlyContentSubTypeAndStatusQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "e3b5b71fba9dd3f54fb8973290ef6043",
            "id": "4aab61ca8a29b1a5dfaedd2cb2eb2392eaeb65d57e63642b5704289a568bf312",
            "metadata": {},
            "name": "useRenderLivePageEarlyContentSubTypeAndStatusQuery",
            "operationKind": "query",
            "text": "query useRenderLivePageEarlyContentSubTypeAndStatusQuery($contentId:ID!,$versionOverride:Int){content(id:$contentId,version:$versionOverride){nodes{id,status,subType}}}"
        }
    };
}();
$5f3802d139ffef0e$var$node.hash = "8c578b35282d8016db5ec0613d83d461";
var $5f3802d139ffef0e$export$2e2bcd8739ae039 = $5f3802d139ffef0e$var$node;



var $98zed = parcelRequire("98zed");




const $4d9db4017ca6ca1d$export$fb2757b0aa0b047e = (t0)=>{
    const $ = (0, $bDgLe.c)(11);
    const { contentId: contentId, cachedSubType: cachedSubType, cachedIsArchived: cachedIsArchived, renderLivePageAsViewPage: renderLivePageAsViewPage } = t0;
    const { isLive: isLive, isTypeKnown: isTypeKnown } = (0, $98zed.useIsLivePageWithSSR)();
    let t1;
    if ($[0] !== contentId) {
        t1 = {
            contentId: contentId
        };
        $[0] = contentId;
        $[1] = t1;
    } else t1 = $[1];
    const t2 = isTypeKnown || !(!renderLivePageAsViewPage && cachedSubType === "live");
    let t3;
    if ($[2] !== t1 || $[3] !== t2) {
        t3 = {
            variables: t1,
            skip: t2,
            fetchPolicy: "network-only"
        };
        $[2] = t1;
        $[3] = t2;
        $[4] = t3;
    } else t3 = $[4];
    const { data: latestContentData, loading: isContentDataLoading } = (0, $jMyy4.useQueryInterop)((0, $5f3802d139ffef0e$export$2e2bcd8739ae039), {
        ...t3,
        __callerPackage__: "view-page-common"
    });
    if (isTypeKnown) {
        const t4 = Boolean(isLive);
        let t5;
        if ($[5] !== t4) {
            t5 = {
                renderLivePageEarly: t4,
                isLivePageCacheOutdated: false,
                isFastLoadedLivePageArchived: false,
                isLivePageFastLoadedFromSSR: true
            };
            $[5] = t4;
            $[6] = t5;
        } else t5 = $[6];
        return t5;
    }
    const loadedSubType = latestContentData?.content?.nodes?.[0]?.subType;
    const mostRecentSubType = isContentDataLoading ? cachedSubType : loadedSubType;
    const loadedIsArchived = latestContentData?.content?.nodes?.[0]?.status === "archived";
    const mostRecentIsArchived = isContentDataLoading ? cachedIsArchived : loadedIsArchived;
    const t4 = mostRecentSubType === "live" && !mostRecentIsArchived;
    const t5 = cachedSubType === "live" && !isContentDataLoading && (loadedSubType !== "live" || cachedIsArchived === false && loadedIsArchived === true);
    const t6 = mostRecentSubType === "live" && loadedIsArchived === true && !cachedIsArchived;
    let t7;
    if ($[7] !== t4 || $[8] !== t5 || $[9] !== t6) {
        t7 = {
            renderLivePageEarly: t4,
            isLivePageCacheOutdated: t5,
            isFastLoadedLivePageArchived: t6,
            isLivePageFastLoadedFromSSR: false
        };
        $[7] = t4;
        $[8] = t5;
        $[9] = t6;
        $[10] = t7;
    } else t7 = $[10];
    return t7;
};



var $6fTvc = parcelRequire("6fTvc");








var $kNIYN = parcelRequire("kNIYN");





var $hrAmX = parcelRequire("hrAmX");


var $jAfH5 = parcelRequire("jAfH5");







const $3993000b7971926b$export$d4da30e04f8ef8f8 = 'view-page-main-content-container';
const $3993000b7971926b$var$styles = {
    container: "_3iDTPbf7HF"
};
const $3993000b7971926b$export$1cbdd44a5a1781ff = (t0)=>{
    const $ = (0, $bDgLe.c)(13);
    const { children: children, isFabricPage: isFabricPage, isEmbeddedPage: isEmbeddedPage } = t0;
    const { hasRecs: hasRecs } = (0, $jAfH5.usePageRecommendationData)();
    let t1;
    if ($[0] !== hasRecs || $[1] !== isEmbeddedPage || $[2] !== isFabricPage) {
        t1 = isFabricPage && !hasRecs && !isEmbeddedPage && ((0, $9wGTI.fg)("confluence_frontend_unify_footer_comment_spacing") || (0, $6mKj3.expValEquals)("confluence_unify_footer_comments_space_width", "isEnabled", true));
        $[0] = hasRecs;
        $[1] = isEmbeddedPage;
        $[2] = isFabricPage;
        $[3] = t1;
    } else t1 = $[3];
    const setMinHeight = t1;
    if ((0, $6mKj3.expVal)("cc_view_page_stable_content_tree", "isEnabled", false)) {
        let t2;
        if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
            t2 = [
                (0, $hrAmX.BannerStateContainer)
            ];
            $[4] = t2;
        } else t2 = $[4];
        let t3;
        if ($[5] !== children || $[6] !== setMinHeight) {
            t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kNIYN.Subscribe), {
                to: t2
            }, (bannerState)=>{
                const bannerHeight = bannerState.getTotalHeight();
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                    xcss: setMinHeight ? $3993000b7971926b$var$styles.container : undefined,
                    style: {
                        minHeight: setMinHeight ? `calc(100vh - ${bannerHeight}px - ${46}px - ${64}px - ${14}px)` : undefined
                    },
                    testId: $3993000b7971926b$export$d4da30e04f8ef8f8,
                    "data-vc": $3993000b7971926b$export$d4da30e04f8ef8f8
                }, children);
            });
            $[5] = children;
            $[6] = setMinHeight;
            $[7] = t3;
        } else t3 = $[7];
        return t3;
    }
    if (setMinHeight) {
        let t2;
        if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
            t2 = [
                (0, $hrAmX.BannerStateContainer)
            ];
            $[8] = t2;
        } else t2 = $[8];
        let t3;
        if ($[9] !== children) {
            t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kNIYN.Subscribe), {
                to: t2
            }, (bannerState_0)=>{
                const bannerHeight_0 = bannerState_0.getTotalHeight();
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                    xcss: $3993000b7971926b$var$styles.container,
                    style: {
                        minHeight: `calc(100vh - ${bannerHeight_0}px - ${46}px - ${64}px - ${14}px)`
                    },
                    testId: $3993000b7971926b$export$d4da30e04f8ef8f8,
                    "data-vc": $3993000b7971926b$export$d4da30e04f8ef8f8
                }, children);
            });
            $[9] = children;
            $[10] = t3;
        } else t3 = $[10];
        return t3;
    }
    let t2;
    if ($[11] !== children) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            testId: $3993000b7971926b$export$d4da30e04f8ef8f8,
            "data-vc": $3993000b7971926b$export$d4da30e04f8ef8f8
        }, children);
        $[11] = children;
        $[12] = t2;
    } else t2 = $[12];
    return t2;
};









var $a33Aa = parcelRequire("a33Aa");


var $9T20v = parcelRequire("9T20v");




function $0035dfb85f61bd54$export$d43c540128020838(t0) {
    const $ = (0, $bDgLe.c)(3);
    const { isFabricPage: isFabricPage } = t0;
    let t1;
    let t2;
    if ($[0] !== isFabricPage) {
        t1 = ()=>{
            if (!isFabricPage) {
                if ((0, $6mKj3.expValEquals)("cc_editor_ttvc_ft_split2", "isEnabled", true)) (0, $9T20v.updatePageloadName)("view-page-tiny");
                else (0, $a33Aa.updatePageLoadInteractionName)("view-page-tiny");
            }
        };
        t2 = [
            isFabricPage
        ];
        $[0] = isFabricPage;
        $[1] = t1;
        $[2] = t2;
    } else {
        t1 = $[1];
        t2 = $[2];
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useEffect(t1, t2);
    return null;
}


const $abc768867d8694f5$var$LivePageComponent = (0, $8tF9d.LivePageComponentLoader); // Rough estimate to determine if the page is small enough that the footer sections (comments, end-of-page recs) are likely visible in the initial viewport. Used to prevent the SSR'd omnibar from flashing on small pages where useInView hooks haven't settled yet during hydration.
const $abc768867d8694f5$var$SMALL_PAGE_ADF_LENGTH_THRESHOLD = 2000;
const $abc768867d8694f5$export$7c711af41fff7bc1 = (hasAllowedFeature)=>{
    if ((0, $lTECB.isEmbeddedConfluence_DO_NOT_USE)() || (0, $lJlG6.isMobileApp_DO_NOT_USE)()) return hasAllowedFeature ? (0, $398ES.LoadingPriority).PAINT : (0, $398ES.LoadingPriority).LAZY;
    return null;
};
const $abc768867d8694f5$var$hideDuringPdfPrint = null;
const $abc768867d8694f5$var$FooterLoader = ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8amSw.CustomHeaderFooterLoader), {
            type: (0, $8amSw.CUSTOM_HEADER_FOOTER_TYPES).FOOTER
        });
        $[0] = t0;
    } else t0 = $[0];
    return t0;
}; // NOTE: `contentId` represents the user's intended page but not always the displayed one. During transition to a new page, the component still renders the previous page until ViewPageContainer updates the contentQueryData.
const $abc768867d8694f5$export$77ec5b273f6febda = ({ spaceKey: spaceKey, contentId: contentId, contentHeader: contentHeader, contentScreenStyles: contentScreenStyles, eventHandlers: eventHandlers, titleAndByLineOptions: titleAndByLineOptions, hasByLine: hasByLine = true, hasPageComments: hasPageComments = true, hasSatisfactionSurveys: hasSatisfactionSurveys = true, hasInlineComments: hasInlineComments = true, hasInlineActions: hasInlineActions = true, hasLabels: hasLabels = true, hasReactions: hasReactions = true, hasEOPRecs: hasEOPRecs = true, hasQuickReload: hasQuickReload = true, hasProgressiveRendering: hasProgressiveRendering, appearance: appearance, children: children, setHasCoverPicture: setHasCoverPicture, isEmbeddedPage: isEmbeddedPage, ClassicEditorContextProviderLoader: ClassicEditorContextProviderLoader, renderLivePageAsViewPage: renderLivePageAsViewPage = false, cachedPageData: cachedPageData = {}, disableTableOverflowShadow: disableTableOverflowShadow, onCurrentContentBodyDynamicChange: onCurrentContentBodyDynamicChange })=>{
    const { locale: locale } = (0, $bQm3c.useSessionData)();
    const isRenderServerPlaceholder = (0, $e4o8D.useRenderServerPlaceholder)();
    const setContentLastModifiedTimestamp = (0, $hq2Sz.useSetContentLastModifiedTimestamp)();
    const { isLivePage: isLivePageOnSSR } = (0, $60cDW.getSSRRenderInputs)();
    const { resetInitialDataLoadedMap: resetInitialDataLoadedMap } = (0, $3mVfX.useCommentsPanelActions)();
    const { clearCommentsData: clearCommentsData } = (0, $8i27m.useCommentsDataActions)();
    const { clearProcessedData: clearProcessedData } = (0, $4L9ve.useProcessedCommentsDataActions)();
    const { clearMentionsFlags: clearMentionsFlags } = (0, $hdxAi.useMentionsNotificationsActions)();
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { isAIEnabledForContent: isAIEnabledForContent, isRovoEnabledForContent: isRovoEnabledForContent } = (0, $7mpOv.useIsAIEnabledForContent)({
        contentId: contentId
    });
    let { embeddedConfluenceSource: embeddedConfluenceSource } = (0, $1eD4P.useReactProps_DO_NOT_USE)() || {};
    if (!embeddedConfluenceSource && isEmbeddedPage && !isRenderServerPlaceholder && typeof location !== 'undefined') embeddedConfluenceSource = (0, $jiJCD.parse)(location.search, true).query.embeddedConfluenceSource?.toString();
    const isPdfExport = (0, $1NBp8.PDF_EXPORT_PAGE).match(window.location.pathname);
    const [quickReloadReady, setQuickReloadReady] = (0, $cozmU.useState)(false);
    const quickReloadLastPollTimeRef = (0, $cozmU.useRef)(null);
    (0, $cozmU.useEffect)(()=>{
        if (!hasQuickReload) return;
        if (quickReloadLastPollTimeRef.current === null) quickReloadLastPollTimeRef.current = Date.now();
        setQuickReloadReady(true);
    }, [
        hasQuickReload
    ]);
    const isReadingAidsAutoHighlightEnabled = (isAIEnabledForContent || isRovoEnabledForContent) && locale.startsWith('en'); // Setup for A/A experiment for testing stratified sampling with Statsig
    (0, $6mKj3.expVal)('cc_stratified_sampling_exp_aa', 'cohort', 'not-controlled');
    let stickyHeader = contentHeader;
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const { setIsLive: setIsLive } = (0, $efvKr.useLivePageStoreActions)();
    const omnibarEligibility = (0, $586b596f3637df5c$export$a4a828fdcd26ce47)(isLivePage || !!isPdfExport || !!isEmbeddedPage);
    const isReactionsEnabled = (0, $l5y3Y.useIsReactionsEnabled)(contentId);
    const [pageCommentsSectionRef, pageCommentsSectionInView] = (0, $5sUij.useInView)();
    const [endOfPageRecRef, endOfPageRecInView] = (0, $5sUij.useInView)();
    const { showCommentsPanel: showCommentsPanel } = (0, $5fMeR.useShowCommentsPanel)();
    const [hasInViewSettled, setHasInViewSettled] = (0, $cozmU.useState)(false);
    (0, $cozmU.useEffect)(()=>{
        const frame = requestAnimationFrame(()=>{
            setHasInViewSettled(true);
        });
        return ()=>cancelAnimationFrame(frame);
    }, []); // Refs for omnibar small-page heuristic instrumentation (false positive detection).
    const suppressedDueToSmallPageHeuristicRef = (0, $cozmU.useRef)(false);
    const lastSuppressedAdfLengthRef = (0, $cozmU.useRef)(0);
    const hasFiredOmnibarHeuristicEventRef = (0, $cozmU.useRef)(false);
    const { setActiveHighlight: setActiveHighlight } = (0, $9jl6v.useInlineCommentsDispatchContext)();
    const shouldShowBylineReactions = hasReactions && !isLivePage;
    const setLivePageGlobalState = (0, $cozmU.useCallback)((isContentLive)=>{
        setIsLive(isContentLive);
        (0, $78QFu.setIsLivePage)(isContentLive); // page load state used for analytics context (e.g. for experience tracking)
    }, [
        setIsLive
    ]);
    (0, $3nzqU.useAmplitudeSessionReplay)({
        skip: !(0, $9wGTI.fg)('cc_engagement_amplitude_session_replay_gate')
    });
    (0, $cozmU.useEffect)(()=>{
        if (!isLivePage) return; // no cleanup needed
        // This is the cleanup function that runs when the component unmounts
        return ()=>{
            setLivePageGlobalState(false);
        };
    }, [
        isLivePage,
        setLivePageGlobalState
    ]); // Update view-page experience with `isLivePage` attribute to ensure all future experience fails denote whether it was on a live page
    (0, $cozmU.useEffect)(()=>{
        const experienceState = experienceTracker.getExperienceState((0, $irVI7.VIEW_PAGE_EXPERIENCE));
        if (experienceState?.attributes?.contentId === contentId && experienceState?.attributes?.isLivePage !== isLivePage) experienceTracker.updateAttributes({
            name: (0, $irVI7.VIEW_PAGE_EXPERIENCE),
            attributes: {
                isLivePage: isLivePage
            }
        });
    }, [
        contentId,
        isLivePage,
        experienceTracker
    ]); // stickyHeader needs to be removed based on live page state since it's used in ViewPageContainer props
    if (isLivePage) stickyHeader = undefined;
    const { renderLivePageEarly: renderLivePageEarly, isLivePageCacheOutdated: isLivePageCacheOutdated, isFastLoadedLivePageArchived: isFastLoadedLivePageArchived, isLivePageFastLoadedFromSSR: isLivePageFastLoadedFromSSR } = (0, $4d9db4017ca6ca1d$export$fb2757b0aa0b047e)({
        contentId: contentId,
        cachedSubType: cachedPageData.subType,
        cachedIsArchived: cachedPageData.isArchived,
        renderLivePageAsViewPage: renderLivePageAsViewPage
    });
    (0, $cozmU.useEffect)(()=>{
        if (renderLivePageEarly) setLivePageGlobalState(true);
    }, [
        renderLivePageEarly,
        setLivePageGlobalState
    ]);
    (0, $cozmU.useEffect)(()=>{
        return ()=>{
            resetInitialDataLoadedMap();
            clearCommentsData();
            clearProcessedData();
            clearMentionsFlags();
            setActiveHighlight(null);
            hasFiredOmnibarHeuristicEventRef.current = false;
        }; // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        contentId
    ]);
    let livePageFastLoadedSource = '';
    if (renderLivePageEarly) {
        if (isLivePageFastLoadedFromSSR) livePageFastLoadedSource = 'SSR';
        else if (cachedPageData?.gqlType) livePageFastLoadedSource = `GQL:${cachedPageData.gqlType}`;
        else livePageFastLoadedSource = 'Unknown';
    }
    const { successfulExperiences: previousRouteSuccessfulExperiences } = (0, $fGzMp.getPreviousRouteExperienceData)();
    const livePagePerfData = (0, $cozmU.useMemo)(()=>({
            renderLivePageEarly: renderLivePageEarly,
            isLivePageCacheOutdated: isLivePageCacheOutdated,
            isFastLoadedLivePageArchived: isFastLoadedLivePageArchived,
            isLivePageFastLoadedFromSSR: isLivePageFastLoadedFromSSR,
            livePageFastLoadedSource: livePageFastLoadedSource,
            contentExtensionMetrics: {},
            previousRouteSuccessfulExperiences: Array.from(previousRouteSuccessfulExperiences)
        }), [
        renderLivePageEarly,
        isLivePageCacheOutdated,
        isFastLoadedLivePageArchived,
        isLivePageFastLoadedFromSSR,
        livePageFastLoadedSource,
        previousRouteSuccessfulExperiences
    ]);
    const panelsModuleKeysAtlGeneral = (0, $juCeZ.useConnectAppsData)({
        contentId: contentId,
        location: (0, $eSLr0.ATL_GENERAL)
    });
    const panelsModuleKeysAtlFooter = (0, $juCeZ.useConnectAppsData)({
        contentId: contentId,
        location: (0, $eSLr0.ATL_FOOTER)
    });
    const customPerfData = {
        ...livePagePerfData,
        webPanelsAtlGeneral: panelsModuleKeysAtlGeneral,
        webPanelsAtlFooter: panelsModuleKeysAtlFooter,
        ...embeddedConfluenceSource ? {
            embeddedConfluenceSource: embeddedConfluenceSource
        } : {}
    };
    const { isAMN: isAMN, isLoading: isAMNPagePropertiesLoading, isRecurringParent: isRecurringParent, isLiveAMNPage: isLiveAMNPage } = (0, $iSXh4.useAutomatedMeetingNotesPageProperties)(contentId);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const hasAudioButton = (0, $fzhfU.useHasAudioButton)(isAIEnabledForContent);
    (0, $cozmU.useEffect)(()=>{
        // maintain analytics for AMN page views without triggering spotlight
        if (!isAMNPagePropertiesLoading && isAMN) createAnalyticsEvent({
            type: 'sendScreenEvent',
            data: {
                name: 'viewAMNPage',
                attributes: {
                    isLivePage: isLiveAMNPage,
                    isRecurringParent: isRecurringParent,
                    referralSource: (0, $iVU5h.getAMNReferralSourceFromQueryParam)()
                }
            }
        }).fire();
    }, [
        contentId,
        isAMN,
        isRecurringParent,
        isLiveAMNPage,
        isAMNPagePropertiesLoading,
        createAnalyticsEvent
    ]); // Fire track event when omnibar small-page heuristic settles to detect false positives.
    (0, $cozmU.useEffect)(()=>{
        if (!hasInViewSettled || !suppressedDueToSmallPageHeuristicRef.current) return;
        const wasFalsePositive = !pageCommentsSectionInView && !endOfPageRecInView;
        const adfLength = lastSuppressedAdfLengthRef.current;
        createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                source: 'viewPageCommon',
                action: wasFalsePositive ? 'falsePositive' : 'truePositive',
                actionSubject: 'omniBar',
                actionSubjectId: 'omniBarSmallPageHeuristic',
                attributes: {
                    contentId: contentId,
                    adfLength: adfLength,
                    commentsSectionInView: pageCommentsSectionInView,
                    endOfPageRecInView: endOfPageRecInView
                }
            }
        }).fire();
        suppressedDueToSmallPageHeuristicRef.current = false;
        hasFiredOmnibarHeuristicEventRef.current = true;
    }, [
        hasInViewSettled,
        pageCommentsSectionInView,
        endOfPageRecInView,
        contentId,
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jFm04.ContentOwnershipContextProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fNzRA.ObjectCommentProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4r9Ir.NewCommentsProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7IghX.PageCommentsCountProvider), {
        contentId: contentId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a8ZQ3.DocumentUpdateStatusProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5pQ1Y.ContentRefetchProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8WQTF.RendererActionsProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cZa7r.AnnotationsProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cryCi.Provider), null, renderLivePageEarly ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $36bdded0429e1042$export$894ebd5d2e91304b), {
        contentId: contentId,
        onCurrentContentBodyDynamicChange: onCurrentContentBodyDynamicChange
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2VZOl.NativeCollabPresenceStateContainer), {
        scope: contentId
    }, (0, $9wGTI.fg)('cc-engagement-nth-user-teammate-rollout-gate') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cfdf4590bc9d9b83$export$f9de7c50725ea941), {
        contentId: contentId,
        isLivePage: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $61182ec78da4ef5a$export$fa7cecb87e076447), {
        contentId: contentId,
        isLivePage: true
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($abc768867d8694f5$var$LivePageComponent, {
        contentId: contentId,
        spaceKey: spaceKey,
        ClassicEditorContextProviderLoader: ClassicEditorContextProviderLoader,
        customPerfData: customPerfData,
        loadingPriority: $abc768867d8694f5$export$7c711af41fff7bc1(true),
        isFastLoaded: true,
        hasByLineContributors: titleAndByLineOptions?.hasByLineContributors ?? true,
        hasByLineExtensions: titleAndByLineOptions?.hasByLineExtensions ?? true,
        hasReactions: hasReactions,
        hasPageComments: hasPageComments,
        hasInlineComments: hasInlineComments
    }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aXika.ViewPageContainer), {
        spaceKey: spaceKey,
        contentId: contentId,
        stickyHeader: stickyHeader,
        contentScreenStyles: contentScreenStyles,
        customPerfData: customPerfData,
        isEmbeddedPage: isEmbeddedPage
    }, ({ isThemed: isThemed, contentQueryData: contentQueryData, contentQueryError: contentQueryError })=>{
        const contentStatus = contentQueryData?.content?.nodes?.[0]?.status;
        const contentType = contentQueryData?.content?.nodes?.[0]?.type;
        const contentSubType = contentQueryData?.content?.nodes?.[0]?.subType;
        const contentTitle = contentQueryData?.content?.nodes?.[0]?.title;
        const spaceId = contentQueryData?.content?.nodes?.[0]?.space?.id;
        const contentIdFromQuery = contentQueryData?.content?.nodes?.[0]?.id;
        const contentBodyDynamic = contentQueryData?.content?.nodes?.[0]?.body?.dynamic;
        const lastModifiedDate = contentQueryData?.content?.nodes?.[0]?.metadata?.lastModifiedDate;
        setContentLastModifiedTimestamp(lastModifiedDate);
        const pageWidthType = contentQueryData?.content?.nodes?.[0]?.appearancePublished?.nodes?.[0]?.value || `"default"`;
        const isFabricPage = Boolean(contentQueryData?.content?.nodes?.[0]?.body?.dynamic?.representation === 'atlas_doc_format');
        const showAIButton = (contentType === 'page' || contentType === 'blogpost') && !isEmbeddedPage;
        const shouldShowEOPRecommendations = hasEOPRecs && (contentType === 'page' || contentType === 'blogpost') && !(isEmbeddedPage && (0, $6mKj3.UNSAFE_isExperimentEnabledNoExposure)('cc-maui-experiment'));
        const showAIButtonForTinyMCE = !isFabricPage;
        const adfValue = contentQueryData?.content?.nodes?.[0]?.body?.dynamic?.value;
        const isLikelySmallPage = typeof adfValue === 'string' && adfValue.length < $abc768867d8694f5$var$SMALL_PAGE_ADF_LENGTH_THRESHOLD;
        const shouldSuppressOmnibarForSmallPage = !hasInViewSettled && isLikelySmallPage && (hasPageComments || shouldShowEOPRecommendations); // Spark-only Agent Trust Receipt preview wiring. Real page data hydrates the
        // CREATED_BY_AI receipt; all fields are already loaded by ContentUnifiedQuery.
        const contentNode = contentQueryData?.content?.nodes?.[0];
        const agentTrustReceipt = isFabricPage && contentIdFromQuery && (0, $9wGTI.fg)('cc_sparks_agent_trust_receipt') ? (0, $e2zD6.resolveAgentTrustReceipt)(contentIdFromQuery, {
            generatedBy: contentNode?.contentProperties?.latest?.generatedBy,
            creatorName: contentNode?.history?.createdBy?.displayName,
            createdAt: contentNode?.history?.createdDate,
            lastUpdatedAt: contentNode?.version?.when,
            versionNumber: contentNode?.version?.number
        }) : null;
        if (shouldSuppressOmnibarForSmallPage) {
            suppressedDueToSmallPageHeuristicRef.current = true;
            lastSuppressedAdfLengthRef.current = typeof adfValue === 'string' ? adfValue.length : 0;
        }
        if (isLikelySmallPage && (hasPageComments || shouldShowEOPRecommendations) && !suppressedDueToSmallPageHeuristicRef.current && !hasFiredOmnibarHeuristicEventRef.current) {
            suppressedDueToSmallPageHeuristicRef.current = true;
            lastSuppressedAdfLengthRef.current = typeof adfValue === 'string' ? adfValue.length : 0;
        } // getting info cover picture needs
        const { coverPicture: coverPicture, contentAppearance: contentAppearance, hasCoverPicture: hasCoverPicture, coverPictureWidth: coverPictureWidth } = (0, $3WPGR.getRendererCoverPictureInfo)(contentQueryData, false); // getting info for auto conversion
        const { queryDataId: queryDataId, editorProperty: editorProperty, isAutoConverted: isAutoConverted, fabricEditorSupported: fabricEditorSupported } = (0, $ayQVU.getAutoConvertionInfo)(contentQueryData?.content?.nodes?.[0]); // If live page is archived, we don't show LivePageComponent. Instead, archived live pages will render using the existing ViewPageContentRenderer.
        const isContentLive = isLivePageOnSSR || contentQueryData?.content?.nodes?.[0]?.subType === (0, $83sfO.LIVE_PAGE_SUBTYPE) && contentStatus !== 'archived';
        setLivePageGlobalState(isContentLive); // Content property values are JSON-stringified by the API;
        // contentQueryData may be page or blog union; blog nodes lack
        // agentSessionsMarker, so narrow with 'in' before accessing.
        const cuqNode = contentQueryData?.content?.nodes?.[0];
        const agentSessionsMarkerValue = cuqNode != null && 'agentSessionsMarker' in cuqNode ? cuqNode.agentSessionsMarker?.nodes?.[0]?.value : undefined; // Gate on the experiment as well as the marker so this acts as a
        // kill-switch: turning cc_ai_agent_mention_from_comment off makes
        // hasCommentSessions false everywhere without reverting code.
        const hasCommentSessions = agentSessionsMarkerValue === 'true' && (0, $6mKj3.expValEquals)('cc_ai_agent_mention_from_comment', 'isEnabled', true);
        if (isContentLive && !contentQueryError && !!contentIdFromQuery && !renderLivePageAsViewPage) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $92fa5c1401245a45$export$3776ef07d76bd666), {
            contentId: contentId,
            contentIdFromQuery: contentIdFromQuery,
            contentBodyDynamic: contentBodyDynamic,
            onCurrentContentBodyDynamicChange: onCurrentContentBodyDynamicChange
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2VZOl.NativeCollabPresenceStateContainer), {
            scope: contentId
        }, (0, $9wGTI.fg)('cc-engagement-nth-user-teammate-rollout-gate') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cfdf4590bc9d9b83$export$f9de7c50725ea941), {
            contentId: contentIdFromQuery,
            isLivePage: true
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $61182ec78da4ef5a$export$fa7cecb87e076447), {
            contentId: contentIdFromQuery,
            isLivePage: true
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($abc768867d8694f5$var$LivePageComponent, {
            contentId: contentIdFromQuery,
            spaceKey: spaceKey,
            ClassicEditorContextProviderLoader: ClassicEditorContextProviderLoader,
            customPerfData: customPerfData,
            isFastLoaded: false,
            hasByLineContributors: titleAndByLineOptions?.hasByLineContributors ?? true,
            hasByLineExtensions: titleAndByLineOptions?.hasByLineExtensions ?? true,
            hasReactions: hasReactions,
            hasPageComments: hasPageComments,
            hasInlineComments: hasInlineComments,
            hasCommentSessions: hasCommentSessions
        })));
        if (!!setHasCoverPicture) setHasCoverPicture(hasCoverPicture);
        const livePagePublishExperienceState = experienceTracker.getExperienceState((0, $irVI7.LIVE_PAGE_PUBLISH_EXPERIENCE));
        if (livePagePublishExperienceState && !livePagePublishExperienceState.hasStopped && livePagePublishExperienceState.attributes?.contentId === contentId) {
            // Succeed the live-page/publish and live-page-session experiences on render of view page content after conversion to page
            experienceTracker.succeed({
                name: (0, $irVI7.LIVE_PAGE_PUBLISH_EXPERIENCE)
            });
            experienceTracker.succeed({
                name: (0, $irVI7.LIVE_PAGE_SESSION_EXPERIENCE),
                attributes: {
                    convertedToPage: true
                }
            });
        } // Relay results are readonly; import helpers use a mutable ContentQueryData shape.
        // Cast avoids generic T inference fighting over page vs blog query unions.
        const importedContentSource = (0, $aK6zf.getImportSource)(contentQueryData);
        const importedContentDate = (0, $aK6zf.getImportDate)(contentQueryData);
        const isImportBannerShown = (0, $aK6zf.isImportBannerEnabled)(contentQueryData) && importedContentSource && importedContentDate;
        const maybeScrollToPageStart = Boolean(window.__SSR_RENDERED__) && (0, $6mKj3.expVal)('confluence_p2m_style_recalc_and_expand_joint_exp', 'isEnabled', false) ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kJNMt.ScrollToPageStart), {
            key: `ScrollToPageStart-${contentId}`,
            isSmooth: false
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, maybeScrollToPageStart, (0, $9wGTI.fg)('cc-engagement-nth-user-teammate-rollout-gate') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cfdf4590bc9d9b83$export$f9de7c50725ea941), {
            contentId: contentId,
            isLivePage: false
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $61182ec78da4ef5a$export$fa7cecb87e076447), {
            contentId: contentId,
            isLivePage: false
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3993000b7971926b$export$1cbdd44a5a1781ff), {
            isFabricPage: isFabricPage,
            isEmbeddedPage: isEmbeddedPage
        }, isThemed && contentHeader, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $0035dfb85f61bd54$export$d43c540128020838), {
            isFabricPage: isFabricPage
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8amSw.CustomHeaderFooterLoader), {
            type: (0, $8amSw.CUSTOM_HEADER_FOOTER_TYPES).HEADER
        }), isImportBannerShown && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $99af38a0b1766526$export$f2bf6e79bf9b9470), {
            importSource: importedContentSource,
            importDate: importedContentDate,
            contentId: contentId
        }), hasCoverPicture && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3oWMY.RendererPageCoverPicture), {
            contentId: contentId,
            isPagePreview: false,
            coverPicture: coverPicture,
            contentAppearance: contentAppearance,
            isSpaceOverview: false,
            coverPictureWidthOverride: coverPictureWidth
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6UMDm.AutoConversionByLineContextProvider), {
            editorProperty: editorProperty,
            fabricEditorSupported: fabricEditorSupported,
            isAutoConverted: !!isAutoConverted,
            queryDataId: queryDataId
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8SCD6.ReactionsProvider), {
            contentId: contentId
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dGhsu.ContentTitleWithByLine), {
            banner: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $deZfn.ArchivedPageBanner), {
                contentId: contentId
            }),
            contentId: contentId,
            spaceKey: spaceKey || '',
            contentFragmentRef: contentQueryData?.content?.nodes?.[0]?.contentTitleWithByLine,
            byLineContributors: contentQueryData?.contentContributors,
            titleSpaceFragmentRef: contentQueryData?.space,
            hasCoverPicture: hasCoverPicture,
            pageWidthType: pageWidthType,
            isEmbeddedPage: isEmbeddedPage,
            shouldShowBylineReactions: shouldShowBylineReactions,
            contentType: contentType,
            contentSubType: contentSubType,
            spaceId: spaceId,
            ...titleAndByLineOptions,
            hasByLine: hasByLine
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $92fa5c1401245a45$export$3776ef07d76bd666), {
            contentId: contentId,
            contentIdFromQuery: contentIdFromQuery,
            contentBodyDynamic: contentBodyDynamic,
            onCurrentContentBodyDynamicChange: onCurrentContentBodyDynamicChange
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6fTvc.ViewPageContentWithStatus), {
            hasInlineComments: hasInlineComments,
            hasProgressiveRendering: hasProgressiveRendering,
            contentId: contentId,
            data: contentQueryData,
            error: contentQueryError,
            spaceKey: spaceKey,
            eventHandlerOverrides: eventHandlers,
            appearance: appearance,
            hasInlineActions: hasInlineActions,
            lastModifiedDate: lastModifiedDate || undefined,
            isEmbeddedPage: isEmbeddedPage,
            customPerfData: customPerfData,
            disableTableOverflowShadow: (0, $6mKj3.expValEquals)('platform_editor_table_css_overflow_shadow', 'isEnabled', true) ? disableTableOverflowShadow : undefined
        }), hasInlineComments && !isFabricPage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4yKPM.InlineCommentsHighlighterLoader), {
            pageId: contentId
        }), isReadingAidsAutoHighlightEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6pBXK.ReadingAidsAcronymsHighlighter), {
            contentId: contentId
        }), hasLabels && (isFabricPage && (0, $9wGTI.fg)('confluence_frontend_labels_in_footer') ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kZEms.ViewPageLabelsLoader), {
            pageWidthType: pageWidthType,
            contentId: contentId,
            contentType: contentType,
            spaceKey: spaceKey,
            spaceId: spaceId,
            contentSubType: contentSubType
        })), shouldShowEOPRecommendations && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            ref: endOfPageRecRef,
            "data-vc": "eop-recommendations-wrapper"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fIKxq.EndOfPageRecommendationFinalLoader), {
            entityType: contentType || '',
            entityId: contentId,
            spaceKey: spaceKey || '',
            pageWidthType: pageWidthType
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fyPYm.ContentViewedEvent), {
            contentId: contentId
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hd53J.CommentsDataBackgroundLoader), {
            contentId: contentId
        })), isFabricPage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            "data-vc": "object-sidebar-wrapper",
            className: (0, $hekY6.default)([
                (0, $6mKj3.expValEquals)('afm-hide-elements-from-pdf-print', 'isEnabled', true) && "_08KCXeYbGa"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lrMxq.ObjectSidebarControl), {
            hasCommentsButton: true,
            hasDetailsButton: true,
            hasLoomButton: contentStatus !== 'archived',
            hasAiButton: showAIButton,
            hasRemixButton: true,
            hasAgentReceiptButton: !!agentTrustReceipt,
            agentTrustReceipt: agentTrustReceipt,
            contentId: contentId,
            spaceKey: spaceKey,
            contentType: contentType,
            contentTitle: contentTitle,
            lastModifiedDate: lastModifiedDate,
            pageCommentsSectionInView: pageCommentsSectionInView,
            contentIdFromQuery: contentIdFromQuery,
            contentBodyDynamic: contentBodyDynamic,
            hasAudioButton: hasAudioButton
        }))), !isLivePage && !isPdfExport && !shouldSuppressOmnibarForSmallPage && !pageCommentsSectionInView && !endOfPageRecInView && isReactionsEnabled && omnibarEligibility.showReactions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $be5272beb8fc0b67$export$e7639907c46a9b3c), {
            value: omnibarEligibility
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8SCD6.ReactionsProvider), {
            contentId: contentId
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $695c4789ab8d8ace$export$621326c554b583ec), null))), hasPageComments && /* Disable unsupported page comments when rendering live page as view page */ !isLivePage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2xS8W.StickyDraftCommentContainer), {
            pageWidthType: pageWidthType,
            key: `StickyDraftCommentContainer-${contentId}`
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6H0Pg.default), {
            name: "renderer-footer-comments"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            ref: pageCommentsSectionRef,
            "data-vc": "footer-comments"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $70pcM.ObjectCommentWrapper), {
            showLabels: Boolean(hasLabels) && isFabricPage,
            pageWidthType: pageWidthType,
            key: `ObjectCommentWrapper-${contentId}`,
            hasReactions: hasReactions,
            hasCommentSessions: hasCommentSessions
        })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dJ5r4.ViewCommentShortcutListener), {
            isFabricPage: isFabricPage,
            contentId: contentId
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($abc768867d8694f5$var$FooterLoader, null), isFabricPage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iNYtG.PageCommentsPubSubHandler), {
            contentId: contentId,
            contentType: contentType
        }), hasQuickReload && quickReloadReady && quickReloadLastPollTimeRef.current !== null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jXhAV.QuickReload), {
            contentId: contentId,
            contentType: contentType,
            // See notes in quick-reload
            // package on what a more correct lastPollTime value would be.
            lastPollTime: quickReloadLastPollTimeRef.current,
            pageMode: (0, $fSC8h.PageMode).RENDERER,
            pageCommentsSectionInView: pageCommentsSectionInView,
            isFabricPage: isFabricPage,
            showCommentsPanel: showCommentsPanel
        }), hasSatisfactionSurveys && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $889eab36c217c00c$export$bdd4a5944172b352), {
            contentId: contentId,
            isEditorExpEnabled: (0, $9wGTI.fg)('cc_onboarding_experience')
        }), contentType === 'page' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cMKmt.LocalActivityViewPageTracker), {
            contentId: contentId
        }), children, hasInlineComments && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9450efcd5fbf758a$export$9fdf0be90cc81aa6), {
            key: contentId,
            loadingPriority: $abc768867d8694f5$export$7c711af41fff7bc1(hasInlineComments),
            contentId: contentId,
            isFabricPage: isFabricPage
        }), contentType === 'page' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cmBjr.ConvertToLivePageFlag), null), (0, $6mKj3.expVal)('confluence_modernized_move_dialog', 'isEnabled', false) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lfmjq.MovePageSuccessFlag), null), showAIButton && showAIButtonForTinyMCE && !(0, $6mKj3.expVal)('confluence_clean_up_legacy_ai_button', 'isEnabled', false) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f23f475309e66803$export$9533f8bbe7f6f635), {
            spaceKey: spaceKey ?? '',
            contentId: contentId,
            contentType: contentType,
            lastModifiedDate: lastModifiedDate,
            pageCommentsSectionInView: pageCommentsSectionInView,
            contentIdFromQuery: contentIdFromQuery,
            contentBodyDynamic: contentBodyDynamic
        }));
    }))))))))))));
};
module.exports["ViewPageCommon"] = $abc768867d8694f5$export$77ec5b273f6febda;

});

parcelRegister("95SZM", function(module, exports) {

let $69ef3da800b61033$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $69ef3da800b61033$var$load("6wr18"),
    $69ef3da800b61033$var$load("4Xum5"),
    $69ef3da800b61033$var$load("kfogw"),
    $69ef3da800b61033$var$load("kyYCx"),
    $69ef3da800b61033$var$load("hOaAV"),
    $69ef3da800b61033$var$load("6XCf4"),
    $69ef3da800b61033$var$load("fINdN"),
    $69ef3da800b61033$var$load("hSDwk"),
    $69ef3da800b61033$var$load("aEiTV"),
    $69ef3da800b61033$var$load("1qlDN"),
    $69ef3da800b61033$var$load("1yVM6"),
    $69ef3da800b61033$var$load("ffEVr"),
    $69ef3da800b61033$var$load("3tGwt")
]).then(()=>parcelRequire('6UCCJ'));

});

parcelRegister("6dFT0", function(module, exports) {
"use strict";


let $487472ade577be65$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("clX3F")).shardUrl((parcelRequire("1hiTA")).resolve(id), maxShards));
    };
module.exports = $487472ade577be65$var$load;

});

parcelRegister("clX3F", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.applyShardToDomain = $8fe541edd234eb0b$var$applyShardToDomain;
module.exports.domainShardingKey = void 0;
module.exports.getDomainShardIndex = $8fe541edd234eb0b$var$getDomainShardIndex;
module.exports.shardUrl = $8fe541edd234eb0b$var$shardUrl;
module.exports.shardUrlUnchecked = $8fe541edd234eb0b$var$shardUrlUnchecked;
const $8fe541edd234eb0b$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 */ function $8fe541edd234eb0b$var$getFilenameFromUrlPath(pathname) {
    const lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 */ function $8fe541edd234eb0b$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    const totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        const n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
const $8fe541edd234eb0b$var$trailingShardRegex = /-\d+$/;
/**
 * Removes trailing shard number from subdomain
 */ function $8fe541edd234eb0b$var$removeTrailingShard(subdomain) {
    if (!$8fe541edd234eb0b$var$trailingShardRegex.test(subdomain)) return subdomain;
    const shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 */ function $8fe541edd234eb0b$var$applyShardToDomain(domain, shard) {
    const i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    const shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$8fe541edd234eb0b$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    const firstSubdomain = $8fe541edd234eb0b$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 */ function $8fe541edd234eb0b$var$shardUrlUnchecked(url, maxShards) {
    const parsedUrl = new URL(url);
    const fileName = $8fe541edd234eb0b$var$getFilenameFromUrlPath(parsedUrl.pathname);
    const shardNumber = $8fe541edd234eb0b$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $8fe541edd234eb0b$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 */ function $8fe541edd234eb0b$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$8fe541edd234eb0b$var$globalKeyName]) return url;
    return $8fe541edd234eb0b$var$shardUrlUnchecked(url, maxShards);
}
const $8fe541edd234eb0b$var$domainShardingKey = module.exports.domainShardingKey = $8fe541edd234eb0b$var$globalKeyName;

});

parcelRegister("1hiTA", function(module, exports) {
$parcel$export(module.exports, "register", () => $0ee60939fdb4dc28$export$6503ec6e8aabbaf, (v) => $0ee60939fdb4dc28$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $0ee60939fdb4dc28$export$f7ad0328861e2f03, (v) => $0ee60939fdb4dc28$export$f7ad0328861e2f03 = v);
var $0ee60939fdb4dc28$export$6503ec6e8aabbaf;
var $0ee60939fdb4dc28$export$f7ad0328861e2f03;
"use strict";
var $0ee60939fdb4dc28$var$mapping = new Map();
function $0ee60939fdb4dc28$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0ee60939fdb4dc28$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0ee60939fdb4dc28$var$resolve(id) {
    var resolved = $0ee60939fdb4dc28$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0ee60939fdb4dc28$export$6503ec6e8aabbaf = $0ee60939fdb4dc28$var$register;
$0ee60939fdb4dc28$export$f7ad0328861e2f03 = $0ee60939fdb4dc28$var$resolve;

});

parcelRegister("keBh8", function(module, exports) {

let $ebb20791e3c4d999$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ebb20791e3c4d999$var$load("5W6cv").then(()=>parcelRequire('lCHNh'));

});

parcelRegister("95jar", function(module, exports) {

let $69d372ea2625edd7$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $69d372ea2625edd7$var$load("eLdMT").then(()=>parcelRequire('2r0OO'));

});

parcelRegister("72oMs", function(module, exports) {

let $51fbf138ae844d21$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $51fbf138ae844d21$var$load("cJccL").then(()=>parcelRequire('ll9YW'));

});


//# sourceMappingURL=ViewPagePdfExportPage.cf844705.js.map
